﻿// window.assembleString = assembleString;
// import "./docxExport.js";
import { exportCertificateAndContractDocx } from "./docxExport.js";
// import { convertHtmlToDocx } from "./docxExport.js";
import { cloneCertificateForExport, cloneContractForExport } from "./clone.js";
import { buildMaturityTable } from "./maturity.js";
import { buildContractSectionFromHtml } from "./contract.js";
window.exportCertificateAndContractDocx = exportCertificateAndContractDocx;
// window.convertHtmlToDocx = convertHtmlToDocx;
window.cloneCertificateForExport = cloneCertificateForExport;
window.cloneContractForExport = cloneContractForExport;
window.buildMaturityTable = buildMaturityTable;
window.buildContractSectionFromHtml = buildContractSectionFromHtml;


window.getRowOneLastCell = getRowOneLastCell;
window.createDeleteNoteButton = createDeleteNoteButton;
window.removeDeleteNoteButton = removeDeleteNoteButton;
window.handleDeleteNoteClick = handleDeleteNoteClick;
window.fetchImageAsArrayBuffer = fetchImageAsArrayBuffer;
window.cancelUpdate1 = cancelUpdate1;
window.startNewContract = startNewContract;
window.DateTime = DateTime;
window.formData = formData;
window.formatData = formatData;
window.autoData = autoData;
window.mmddyyyyToTimestamp = mmddyyyyToTimestamp;
window.dateTimes = dateTimes;
window.dateTimesA = dateTimesA;
window.interestCalc = interestCalc;
window.overwriteData = overwriteData;
window.clearDocument = clearDocument;
window.setDataAndState = setDataAndState;
window.closeModal = closeModal;
window.confirmDelete = confirmDelete;
window.scroll2 = scroll2;
window.window = window;
//window.addDeleteButtonListeners = addDeleteButtonListeners;
window.addEventListeners = addEventListeners;
window.appendTable = appendTable;
window.appendTable2 = appendTable2;
window.applyComputedStylesToClone = applyComputedStylesToClone;
window.applyContractHistoryToClone = applyContractHistoryToClone;
window.assembleString1 = assembleString1;
window.autoSan = autoSan;
window.bColor = bColor;




window.buildCombinedHtml = buildCombinedHtml;
window.buildContractVersions = buildContractVersions;
window.buildMaturityTableA = buildMaturityTableA;

window.captureValues = captureValues;
window.clear = clear;
window.clearData = clearData;
window.clearDisplay = clearDisplay;
window.clearInput = clearInput;
window.clearUploads = clearUploads;
window.clientPaperwork = clientPaperwork;
window.closeModal = closeModal;
window.collectImagesFromRoot = collectImagesFromRoot;
window.confirmDelete = confirmDelete;
window.conflictDiv = conflictDiv;
window.contractSeal = contractSeal;
window.contractSeal2 = contractSeal2;
window.contractVersions = contractVersions;
window.convertHtml = convertHtml;
window.createRecord = createRecord;
window.createRecord1 = createRecord1;
window.createRecords = createRecords;
window.dataEntry = dataEntry;
window.DataInterface = DataInterface;
window.deleteTableRow = deleteTableRow;
window.deleteThesePayments = deleteThesePayments;
window.displayItem = displayItem;
window.editInvestment = editInvestment;
window.editNote = editNote;
window.editTerms = editTerms;
window.ensureJsTemplateExists = ensureJsTemplateExists;
window.extractVersionFromHtml = extractVersionFromHtml;
window.fetchUpdatedFiles = fetchUpdatedFiles;
window.finalizeFormControlsInClone = finalizeFormControlsInClone;
window.finalizeInvestment = finalizeInvestment;
window.fNum = fNum;
window.formatData = formatData;
window.fTerm = fTerm;
window.generateUniqueMirrorID = generateUniqueMirrorID;
window.getBlank_tr = getBlank_tr;
window.getClientName = getClientName;
window.getLowerLimit = getLowerLimit;
window.getMaturity = getMaturity;
window.getNumber = getNumber;
window.getNumberA = getNumberA;
window.getOriginationA = getOriginationA;
window.getQueryParams = getQueryParams;
window.getString = getString;
window.getTable = getTable;
window.getValue1 = getValue1;
window.handleFileSelection = handleFileSelection;
window.handleLogin = handleLogin;
// window.inchesToTwips = inchesToTwips;
window.indefinite = indefinite;
window.input2 = input2;
window.inputFunction = inputFunction;
window.interestCalc1 = interestCalc1;
window.interestCalc1A = interestCalc1A;
window.interestCalc2 = interestCalc2;
window.interestCalc3 = interestCalc3;
window.interestCalc4 = interestCalc4;
window.investmentValidation = investmentValidation;
window.isEmptyObject = isEmptyObject;
window.mapContractStructure = mapContractStructure;
window.normalizeText = normalizeText;
window.openModal = openModal;

window.paymentAdjustments = paymentAdjustments;
window.processBackendResponse = processBackendResponse;
window.processChanges = processChanges;
window.processResponseData = processResponseData;
window.processString = processString;
window.recalculateTable = recalculateTable;
window.reconstructContract = reconstructContract;
window.reinvestmentAmountAdjustments = reinvestmentAmountAdjustments;
window.removeEventListeners = removeEventListeners;
window.renumberRows = renumberRows;
window.returnOnInvestment = returnOnInvestment;
window.scroll1 = scroll1;
window.scroll2 = scroll2;
window.scroll3 = scroll3;
window.setDataAndState = setDataAndState;
window.setDefault = setDefault;
window.showDiv = showDiv;
window.showMessage = showMessage;

window.submitChanges = submitChanges;
window.submitForm = submitForm;
window.submitFormA = submitFormA;
window.templateExists = templateExists;
window.truncateInput = truncateInput;
window.updateAccountChange = updateAccountChange;
window.updateClientInfo = updateClientInfo;
window.updateContactEmailError = updateContactEmailError;
window.updateTable = updateTable;
window.uploadDocument = uploadDocument;
window.uploadDocuments = uploadDocuments;
window.validateInput = validateInput;
window.validateReinvestmentAmount = validateReinvestmentAmount;
window.validateVersion = validateVersion;
window.verifyCompletion = verifyCompletion;
window.versions = versions;
function scroll2() {
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
};
function scroll1() {
    window.scrollTo({ top: 0, behavior: "smooth" });   
};
function scroll3() {
    window.scrollTo({ top: 500, behavior: "smooth" }); 
}
function formatData() {
    Amount = document.getElementById("amount1").value;
    Amount = getNumber(Amount); 
    Amount = Amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    document.getElementById("amount1").value = Amount;
    return Amount   
}
function fNum(input) {
    //let cString = input.replace(/[\$,]/g, '');
    let cString = input.replace(/[\$]/g, '');
    let num = parseFloat(cString);
    let acctString = num.toFixed(2);
    return acctString;
}
function fTerm(input) {
    let cString = input.replace(/\s*months?/g, '');
    return cString.trim(); // Trim any remaining whitespace
}
function getClientName() {
    //console.log("getClientName(), val clientInfo.firstName:", clientInfo.firstName)
if (clientInfo.firstName) {
    if (clientInfo.firstName && clientInfo.lastName) {
    clientName = clientInfo.firstName + " " + clientInfo.lastName;
    } else {
    clientName = clientInfo.firstName; }
    }
    localStorage.setItem("clientName", clientName); 
}
function handleFileSelection() {
    var input = document.getElementById("docInput");
    //console.log("window.selectedFiles:", window.selectedFiles);
    //console.log("input:", input)
    var files = [];
    files = input.files;
    //console.log("files:", files)
    var fileResult = [];
    for (var i = 0; i < files.length; i++) {
        var file = files[i];
        if (file) {
            fileResult.push(file);
        }
    }
    if (fileResult.length > 0) {
        //console.log("window.selectedFiles:", window.selectedFiles);
        window.selectedFiles = window.selectedFiles.concat(fileResult);
    }
    var fileList = document.getElementById("fileList");
    //console.log("fileList:", fileList);
    fileList.innerHTML = "";
    for (var i = 0; i < window.selectedFiles.length; i++) {
        fileList.innerHTML += window.selectedFiles[i].name + "<br>";
    }
    for (var i = 0; i < window.selectedFiles.length; i++) {
        //console.log(window.selectedFiles[i]);
    }
    var file, input, files;
    fileResult = new Array();
};
function uploadDocuments() {
    //console.log("Preparing to Upload Documents");
    //console.log("record[0]:", record[0])
    let timestamp = "";
    let files = window.selectedFiles;
    if (record[0]) {
        if (record[0].includes(" (Example)")) {
            resultMessage = "Payments on Example Notes Cannot be Updated to the Database:";
            // clear files
            return;
        } 
        //timestamp = new Date(Number(date.trim()));
        timestamp = record[0];
        /*
        try {
            console.log("Timestamp:", timestamp, "typeof:", typeof timestamp )
            if (isNaN(timestamp.getTime())) {
                console.log("Error: Invalid date format:", date);
                return;
            }
            console.log("timestamp 1:", timestamp);
        } catch (error) {
            console.log("Error processing date:", date);
            return;
        }
        */   
    }
    dataSetA[2][12] = "true";
    if (!record[0]) {
        timestamp = "";
    }
    dataSetA[2][5] = "true";
    if (edit) {
        console.log("Uploading Images to Database")
        const action = "uploadImages";
        dataSetA[0][1] = action; 
        dataSetA[1][1] = "POST";
        localStorage.setItem("dataSetA", JSON.stringify(dataSetA));
        (async function () {
        const endpoint = "https://jplbuilders-contracting.com/API/uploadImages";
        let formData = new FormData();
        formData.append("Timestamp", String(timestamp));
        formData.append("action", action);
        formData.append("dataSetA", JSON.stringify(dataSetA));
        //files.forEach((file) => {
        //formData.append("files[]", file); // files, or "files[]" for array keys
        //});
        files.forEach((file, i) => {
            if (!(file instanceof Blob)) {
              console.warn(`?? File #${i} is not a valid Blob`);
            }
            formData.append("files", file);
          });          
        formData.append("uploadSessionId", Date.now().toString());
        let requestOptions = {
            method: 'POST',
            body: formData
          };
        
        try {
        //await DataInterface(requestOptions, endpoint);
        //await fetch(endpoint, {method: "POST", body: formData});
        const response = await fetch(endpoint, {method: "POST", body: formData});
        await new Promise(resolve => setTimeout(resolve, 200));
        if (!response.ok) {
          const text = await response.text();
          const parsed = await response.json();
          console.error("Server responded with error:", response.status, text);
        }
        } catch (error) {
        console.error("Error during DataInterface call:", error);
        resultMessage = "Unknown Error Code 40, Please contact itAdmin" + error;
        }
        })();        
edit = false;
// completed = false;
return;
}
if (contract) {
dataSetA[2][12] = "true";
timestamp = contractA.Timestamp;
action = "createNote";
dataSetA[2][5] = "true";
dataSetA[0][1] = action; dataSetA[1][1] = "POST";
localStorage.setItem("dataSetA", JSON.stringify(dataSetA));
(async function() {
const endpoint = "https://jplbuilders-contracting.com/API/createNote";
let formData = new FormData();
//const items = {
//    action: "createNote",
//  };
formData.append("Timestamp", String(timestamp));
formData.append("action", "createNote");
formData.append("dataSetA", JSON.stringify(dataSetA));
//formData.append("items", JSON.stringify(items));
files.forEach((file, i) => {
    if (!(file instanceof Blob)) {
      console.warn(`?? File #${i} is not a valid Blob`);
    }
    formData.append("files", file);
  });  
//formData.append("uploadSessionId", Date.now().toString());
let requestOptions = {
    method: 'POST',
    body: formData
  };

try {
  //const response = await fetch(endpoint, requestOptions);
  localStorage.removeItem("placeDataInv");
  const response = await DataInterface(requestOptions, endpoint);
  if (!response.ok) {
    const text = await response.text();
    console.error("Server responded with error:", response.status, text);
  }
  if (response.ok) {
    const result = await response.json();
    contractA.Timestamp = result.UUID.trim();
  }
} catch (error) {
  console.error("Error during DataInterface call:", error);
  resultMessage = "Unknown Error Code 40, Please contact itAdmin: " + error;
}
})();        
contract = false;
return;
}
}
function uploadDocument() {
    var files = window.selectedFiles;
    var sales = document.getElementById("closing")
    sales.style.display = "block";
    if (files.length === 0) {
    var complete = false;
    conflictDiv(complete);
    showDiv(complete);
    }
    if (files.length > 0) {
    var complete = true;
    conflictDiv(complete);      
    showDiv(complete);
    };
    contract = true;
    initiateSaveDocument().then(() => {
        dataSetA[7][2] = contractA;
        //dataSetA[7][2] = {};
        //console.log(JSON.parse(JSON.stringify(dataSetA[7][2])));
        uploadDocuments();
        contract = false;
    });
    return;
    }
async function fetchUpdatedFiles() {
    const action = "listPayments";
    dataSetA[0][1] = action;
    dataSetA[1][1] = "POST";
    dataSetA[2][5] = 'true';
    dataSetA[2][12] = "true";
    localStorage.setItem("dataSetA", JSON.stringify(dataSetA));
    dataSetA = JSON.parse(localStorage.getItem("dataSetA"));
  
    const endpoint = "https://jplbuilders-contracting.com/API/listPayments";
    const items = {
      ItemNumber: record[0],
      Username: dataSetA[2][1]
    };
  
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items, dataSetA })
    };
  
    const response = await fetch(endpoint, requestOptions);
    return await response.json();
  }
  
function openModal(files, isConfirmation = false) {
    const overlay = document.getElementById('modalOverlay');
    const list = document.getElementById('modalFileList');
    const heading = document.getElementById('modalHeading');
    const subheading = document.getElementById('modalSubheading');
  
    list.innerHTML = '';
  
    files.forEach(file => {
      const li = document.createElement('li');
      li.textContent = file;
      li.onclick = () => li.classList.toggle('selected');
      list.appendChild(li);
    });
  
    if (isConfirmation) {
      heading.textContent = files.length > 1 ? "Files Deleted" : "File Deleted";
      heading.style.color = "red";
      subheading.classList.remove("hidden");
  
      setTimeout(() => {
        heading.textContent = "Delete Payments";
        heading.style.color = "black";
        subheading.classList.add("hidden");
      }, 3000); // adjustable duration
    } else {
      heading.textContent = "Delete Payments";
      heading.style.color = "black";
      subheading.classList.add("hidden");
    }
  
    overlay.classList.remove('hidden');
  }
  
  
  function closeModal() {
    document.getElementById('modalOverlay').classList.add('hidden');
  }
  
  async function confirmDelete() {
    const selected = [...document.querySelectorAll('.file-list li.selected')].map(li => li.textContent);
    if (selected.length === 0) return;
  console.log("record[0]", record[0])
  console.log("dataSetA[2][1]", dataSetA[2][1])
  console.log("filesToDelete", selected)
    const action = "deletePayments";
    dataSetA[0][1] = action;
    dataSetA[1][1] = "POST";
    dataSetA[2][5] = 'true';
    dataSetA[2][12] = "true";
    localStorage.setItem("dataSetA", JSON.stringify(dataSetA));
    dataSetA = JSON.parse(localStorage.getItem("dataSetA"));
  
    const endpoint = "https://jplbuilders-contracting.com/API/deletePayments";
    const items = {
      ItemNumber: record[0],
      Username: dataSetA[2][1],
      filesToDelete: selected
    };
  
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items, dataSetA })
    };
  
    try {
      const response = await fetch(endpoint, requestOptions);
      const result = await response.json();
  
      // Refresh and show confirmation
      const refreshedFiles = await fetchUpdatedFiles();
      openModal(refreshedFiles, true);
    } catch (error) {
      console.error("? Delete Payments Error:", error);
    }
  }
  

async function deleteThesePayments() {
    const action = "listPayments";
    dataSetA[0][1] = action;
    dataSetA[1][1] = "POST";
    dataSetA[2][5] = 'true';
    dataSetA[2][12] = "true";
    localStorage.setItem("dataSetA", JSON.stringify(dataSetA));
    dataSetA = JSON.parse(localStorage.getItem("dataSetA"));
    const endpoint = "https://jplbuilders-contracting.com/API/listPayments";
    const items = {
        ItemNumber: record[0],
        Username: dataSetA[2][1]
    };
    const requestOptions = {
        method: "POST", // GET with body is invalid � switch to POST
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ items, dataSetA })
    };
    try {
        const response = await fetch(endpoint, requestOptions);
        const files = await response.json(); // if no files?
        console.log("?? Received files:", files);
        openModal(files);
    } catch (error) {
        console.error("? Error during listPayments fetch:", error);
    }
}

function getQueryParams(params) {
    if (!params || typeof params.get !== "function") return;
    const username = params.get("username");
    const contactEmail = params.get("contactEmail")
    const message = params.get("message");
    //console.log("username, message:", username, message)
    // Populate email field
    if (username) {
    document.getElementById("email").value = username;
    }
    // Show message if not null
    if (message) {
    document.getElementById("submitError").textContent = message;
    document.getElementById("message").style.display = "block";
    }
    window.getQueryParams = getQueryParams;
}
function handleLogin(clientIDjs, clientCredentialsjs) {
    let action = "";
    document.getElementById("message").innerText = "\u00A0"; // nbsp
    var createAccountChecked = document.getElementById("createAccount").checked;
    var resetPasswordChecked = document.getElementById("resetPassword").checked;
    if (createAccountChecked && resetPasswordChecked) {
        document.getElementById("createAccount").checked = false;
        document.getElementById("resetPassword").checked = false;
        document.getElementById("message").innerText = "Please Select Only One Action.";
        return;
    }
    var sessionTime = new Date();
    console.log(sessionTime); dataSetA[2][1] = clientIDjs; dataSetA[2][2] = clientCredentialsjs; dataSetA[2][5] = "false";
    //clientIDjs = "";
    //clientCredentialsjs = "";
    if (createAccountChecked) {
        console.log("Creating new account");
        const action = "createAccount";
        dataSetA[0][1] = action;
        dataSetA[1][1] = "POST";
        (async function() {
        const endpoint = "https://jplbuilders-contracting.com/API/register"
        let items = {
        };
        let requestOptions = {
            method: dataSetA[1][1],
            headers: {
                "Access-Control-Allow-Origin": "https://jplbuilders-contracting.com",
                "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
                "Content-Type": "application/json",
                "Access-Control-Allow-Headers": "Content-Type, Access-Control-Allow-Methods",
            },
            body: JSON.stringify({ items, dataSetA })
        };
        document.getElementById("createAccount").checked = false;
        try {
            await DataInterface(requestOptions, endpoint);
            setTimeout(() => {
            }, 200)
        } catch (error) { 
            console.error("Error during DataInterface call:", error);
        }
    })();
    return;     
    }
if (resetPasswordChecked) {
const action = "reset";
dataSetA[0][1] = action; dataSetA[1][1] = "PATCH";
(async function() {
const endpoint = "https://jplbuilders-contracting.com/API/reset"
let items = {  
};
let requestOptions = {
    method: dataSetA[1][1],
    headers: {
        "Access-Control-Allow-Origin": "https://jplbuilders-contracting.com",
        "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "Content-Type, Access-Control-Allow-Methods",
    },
    body: JSON.stringify({ items, dataSetA })
};
document.getElementById("resetPassword").checked = false;
try {
    await DataInterface(requestOptions, endpoint);
    setTimeout(() => {
    }, 200)
    dataSetA = JSON.parse(localStorage.getItem("dataSetA"));
    placeDataInv = JSON.parse(localStorage.getItem("placeDataInv"));
    clientInfo = JSON.parse(localStorage.getItem("clientInfo"));
} catch (error) { 
    console.error("Error during DataInterface call:", error);
}
})();
return;
};
if (!createAccountChecked && !resetPasswordChecked) {
    const action = "login";
    dataSetA[0][1] = action; dataSetA[1][1] = "POST"; dataSetA[2][5] = 'true';
    localStorage.setItem("dataSetA", JSON.stringify(dataSetA));
    dataSetA = JSON.parse(localStorage.getItem("dataSetA"));
    (async function() {
    const endpoint = "https://jplbuilders-contracting.com/API/login";
    let requestOptions = {
        method: dataSetA[1][1],
        headers: {
            "Access-Control-Allow-Origin": "https://jplbuilders-contracting.com",
            "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
            "Content-Type": "application/json",
            "Access-Control-Allow-Headers": "Content-Type, Access-Control-Allow-Methods",
        },
        body: JSON.stringify({ items: {}, dataSetA })
    };
    try {
        const result = await DataInterface(requestOptions, endpoint);
        setTimeout(() => {
        }, 200)
    } catch (error) { 
        console.error("Error during DataInterface call:", error);
        // dataSetA[2][3] = "Server is offline. Please try again later.";
        dataSetA[2][3] = data.message
        dataSetA[2][12] = "false";
        er = document.getElementById("message");
        if (er) er.innerText = dataSetA[2][3];
    } 
})();
    scroll2(); 
    return;
}
};
function updateClientInfo(newInfo) {
    clientInfo = Object.assign(clientInfo || {}, newInfo);
    localStorage.setItem("clientInfo", JSON.stringify(newInfo));
};

function processResponseData(data) {
    return new Promise((resolve, reject) => {
        try {
            let storedDataSetA = JSON.parse(localStorage.getItem("dataSetA"));
            //console.log("dataSetA[2][9]_1", dataSetA[2][9])
            if (!storedDataSetA) return resolve(false);
            storedDataSetA[2][3] = data.message;
            console.log("Message:", data.message)
            //storedDataSetA[2][3] = data.message || storedDataSetA[2][3];
            storedDataSetA[2][4] = data.status;
            storedDataSetA[2][5] = data.dataSetA?.[2]?.[5];
            storedDataSetA[2][6] = data.results || null;
            //storedDataSetA[2][7] = { ...data };
            storedDataSetA[2][7] = data.dataSetA?.[2]?.[7];
            storedDataSetA[2][8] = data.responseType;
            storedDataSetA[2][9] = data.dataSetA?.[2]?.[9];
            //storedDataSetA[2][11] = data.changed;
            storedDataSetA[2][12] = data.dataSetA?.[2]?.[12];
            localStorage.setItem("dataSetA", JSON.stringify(storedDataSetA));
            const er = document.getElementById("message");
            if (er) er.innerText = data.message;
            if (data.placeDataInv) {
                localStorage.setItem("placeDataInv", JSON.stringify(data.placeDataInv));
                placeDataInv = JSON.parse(localStorage.getItem("placeDataInv") || "null");
            }
            if (data.clientInfo) {
                localStorage.setItem("clientInfo", JSON.stringify(data.clientInfo));
                clientInfo = JSON.parse(localStorage.getItem("clientInfo") || "null");
            }
            if (storedDataSetA[0][1] === "login") {
                console.log("login is complete");
            }
            if (storedDataSetA[0][1] === "editProfile") {
            }
            if (storedDataSetA[0][1] === "editNote") {
                if (data.placeDataInv) {
                    console.log("placeDataInv is complete"); 
                }
            }
            
            if (storedDataSetA[0][1] === "getTable") {
                if (data.placeDataInv) {
                    console.log("getTable is complete");
                    //localStorage.setItem("placeDataInv", JSON.stringify(data.placeDataInv));
                }
            }
            dataSetA = JSON.parse(localStorage.getItem("dataSetA"));
            resolve(true);
        } catch (err) {
            console.error("Error in processResponseData:", err);
            reject(err);
        }
    });
}

async function DataInterface(requestOptions, endpoint) {
    const xhr = new XMLHttpRequest();
    const url = endpoint;
    return new Promise((resolve, reject) => {
        xhr.open(requestOptions.method, url, true);
        const isFormData = requestOptions.body instanceof FormData;
        if (!isFormData) {
            xhr.setRequestHeader("Content-Type", "application/json");
        } else {
            //console.log("Setting FormData Headers")
            xhr.setRequestHeader("Access-Control-Allow-Origin", "https://jplbuilders-contracting.com");
            xhr.setRequestHeader("Access-Control-Allow-Headers", "Content-Type, Access-Control-Allow-Methods");
            xhr.setRequestHeader("Access-Control-Allow-Methods", "GET, POST, PUT, OPTIONS");
            //xhr.setRequestHeader("Content-Type", "multipart/form-data");
        }
        xhr.onreadystatechange = async function () {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;
            const status = xhr.status;
            const raw = xhr.responseText;
            if (!raw) {
                dataSetA[2][3] = "Server is offline. Please try again later..";
                dataSetA[2][12] = "false";
                er = document.getElementById("message");
                if (er) er.innerText = dataSetA[2][3];
                return reject(new Error("Server is offline"));
            }
            let data;
            try {
                data = JSON.parse(raw);
            } catch (err) {
                dataSetA[2][3] = "Cloudflare Server if Status 413.";
                dataSetA[2][12] = "false";
                //return reject(new Error("Invalid JSON from server"));
                return reject(new Error("Cloudflare Overprotecting Server if Status 413."));
            }
            if (status >= 200 && status < 300) {
                await processResponseData(data);
                const er = document.getElementById("message");
                if (er) er.innerText = data.message;
                if (dataSetA[2][12] === "(e)") {
                    dataSetA[2][12] = "true";
                    
                    localStorage.setItem("Username", dataSetA[2][1]);
                    window.open("iDashboard.html", "_blank");
                    // window.location.href = "iDashboard.html";
                }
                if (dataSetA[2][5] !== dataSetA[2][12]) {
                }
                return resolve({
                    ok: true,
                    status,
                    json: async () => data,
                    text: async () => raw
                });
            }
            er = document.getElementById("message");
            dataSetA[2][3] = data.message || "Server is Offline. Please Try Again Later...";
            dataSetA[2][4] = data.status;
            dataSetA[2][12] = "false";
            localStorage.setItem("dataSetA", JSON.stringify(dataSetA));
            if (er) er.innerText = dataSetA[2][3];
            return reject(new Error(data.error || "Request failed"));
        };
      xhr.send(requestOptions.body);  
    });
}
function submitForm() { /// is not needed?
    let username = document.getElementById("username").value;
    let password = document.getElementById("password").value;

    const data = {
        Username: username,
        Password: password
    };
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    DataInterface(requestOptions, endpoint); // not using?
}
function buildMaturityTableA(targetContainer, placeDataInv, idNumber, recordNumber) {
    //console.log("buildMaturityTable", idNumber, recordNumber, placeDataInv)
    const record = placeDataInv[recordNumber];
    console.log("placeDataInv[recordNumber]", placeDataInv[recordNumber])
    if (!record) {
        console.log("returning")
        return;
    }
    const title = document.createElement("div");
    title.className = "maturityTitle";
    title.innerText = "REINVESTMENT AND REPAYMENT SCHEDULE";
    targetContainer.appendChild(title);
    const firstKeys = [
        'Timestamp', 'Status', 'investmentAmount', 'interestRate',
        'Term', 'maturityDate', 'earnedInterest',
        'contractCode', 'Value', 'Payment'
    ];
    const keys = [
        'oeTimestamp', 'newTermStatus', 'newAmount', 'newRate',
        'newTerm', 'newMaturity', 'newROI',
        'newRepaymentOptions', 'newValue', 'newPayment'
    ];
    const headings = [
        "NOTE ID", "STATUS", "AMOUNT", "RATE", "TERM",
        "MATURITY", "ROI", "OPTIONS",
        "VALUE", "MATURITY PAYMENT"
    ];
    // const firstStatus = record.Status?.[0] || "Pending";
    // If first row is Pending → entire table suppressed
    //if (firstStatus === "Pending") {
    // console.log("All rows pending — table suppressed");
    //    return;
    //}
    const table = document.createElement("table");
    table.id = "maturityTable";
    const headerRow = document.createElement("tr");
    headings.forEach(h => {
        const th = document.createElement("th");
        th.innerText = h;
        headerRow.appendChild(th);
    });
    table.appendChild(headerRow);
    const firstRow = document.createElement("tr");
    firstKeys.forEach(key => {
        const td = document.createElement("td");
        // COMMENTED OUT: buggy nested access
        // if (key === "Term") {
        //     console.log("BUGGY Term nested:", record.Term.Timestamp, record.Term.Username);
        // }
        // Correct access (array element 0)
        td.innerText = Array.isArray(record[key]) ? record[key][0] : record[key];
        firstRow.appendChild(td);
    });
    table.appendChild(firstRow);
    const rowCount = record.newMaturity?.length || 0;
    for (let i = 0; i < rowCount; i++) {
        // Stop if this row is Pending
        if (record.newTermStatus?.[i] === "Pending") {
            //console.log("Stopping at Pending row", i);
            //break;
        }
        //if (!record.newMaturity[i]) continue;
        const row = document.createElement("tr");
        keys.forEach(key => {
            const td = document.createElement("td");
            td.innerText = record[key]?.[i] || "";
            row.appendChild(td);
        });
        table.appendChild(row);
    }
    //const container = document.getElementById("noteItems");
    //container.appendChild(table);
    targetContainer.appendChild(table);
    console.log("Maturity table appended");
}

function getNumberA(strAmount) {
    let number = 0;
    if(strAmount) {
    number = Number(strAmount.replace(/[^0-9.-]+/g,""));
    }
    return number;
}
function getNumber(strAmount) {
    let number = 0;
    if (typeof strAmount === "string") {
        number = Number(strAmount.replace(/[^0-9.-]+/g, ""));
    } else {
        console.error("Argument is not a string: ", strAmount, typeof strAmount);
        if (typeof strAmount === "number") {
            console.log("Argument passed.")
            number = strAmount;
        }
    }
    return number;
}
function getString(amount) {
    let currency = 0;
    currency = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
    let string = currency.format(amount);
    return string;
}
function autoSan(value) {
    return value || "";
}
function captureValues() {
    let node = document.querySelectorAll("input:not([readonly])");
    let inputs = Array.from(node);
    inputs.forEach(input => {
      if (input.type === "text" || input.type === "email" || input.type === "password") {
        window.same.formFields[input.id] = input.value || "";
      }
    });
    window.same.change1 = {};
    window.same.v = false;
    //console.log("window.same.formFields", window.same.formFields)
}
                                 
function assembleString1() {
    var sections = ["section1", "section2"];
    if (trm[4] === " ") { // alternative is versions()
        console.log("INSIDE EDIT TERMS")
    var section1Checked = Array.from(document.getElementsByClassName("section1")).map(checkbox => checkbox.checked);
    for (i = 0; i < section1Checked.length; i++) {
    if (section1Checked) {
    editTerms(section1Checked)
    }
    }};
    var result = "";
    sections.forEach(function(section) {
    var checkboxes = document.getElementsByClassName(section);
    for (var i = 0; i < checkboxes.length; i++) {
    if (checkboxes[i].checked) {
        result += checkboxes[i].value + " ";
    }
    }
    });
    if (result.length === 3) {
        result += " - "
    }
    result += "C1 Ver 2.5";
    document.getElementById("result").innerText = result;
    itemUpdate[7] = result;
    return   
}
function processString(contractCode) {
    console.log("contractCode", contractCode)
    if (!contractCode) return;
    const trm = contractCode.split(" ");
    const versionRaw = trm[4];
    const version = Math.floor(parseFloat(versionRaw)); // safely parse version
    trm[4] = version.toString();
    for (let i = 0; i < trm.length; i++) {
        const key = trm[i].charAt(0);
        const index = parseInt(trm[i].charAt(1), 10) - 1;
        console.log("key:", key, "index:", index); ////
        if (key === "B") {
            const termSet = ContractTerms?.[version]?.["B"]; ////
            if (termSet && termSet[index]) {
                const interestApr = termSet[index].APR;
                console.log("interestApr:", interestApr);
            } else {
                console.warn(`Missing ContractTerms for version ${version}, key B, index ${index}`);
            }
        }
    }
    return {
        trm,
        version,
        ContractTerms
    };
}
function clearInput() {
    let checkboxA1 = document.getElementById("c2_2option1");
    if (!checkboxA1.checked) {
        document.getElementById("newInvestAmount").value = "";
    }
};
function appendTable(cells, currentTable) {
    let reinvestData = document.createElement("tr");
    for (let cell of cells) {
        if (cell) {
            reinvestData.appendChild(cell);
        }
    }
    var table = currentTable;
    table.appendChild(reinvestData);
}
function getBlank_tr(currentTable, reader, r, reinvestAmount) {
    let button = document.createElement("input");
    let blankRow;
    if (s8 === 4) {
    blankRow = currentTable.insertRow(r + 1);   
    } else {
    blankRow = currentTable.insertRow(-1); // at table end syntax
    }
    for (let x = 0; x < 10; x++) {
        let cell = blankRow.insertCell(x);
        cell.style.width = "auto";
        cell.style.textAlign = "center";
        cell.style.fontWeight = "normal";
        if (x === 0) {
            cell.colSpan = 2;
            cell.textContent = "Reinvestment Amount";
            cell.classList.add("twoLineCell");
            cell.style.fontWeight = "bold";
        } else if (x === 1) {
            cell.textContent = reinvestAmount;
            console.log("********************************************REINVEST_AMOUNT", reinvestAmount)
        } else if (x === 2) { 
        cell.textContent = "";
        } else if (x === 3) { 
            cell.textContent = "";
        } else if (x === 4) {
            if (s8 <= 0) {
            if (reader[r] && reader[r][1] === "Pending") {
            cell.style.color = "rgb(26, 141, 234)";
            } else if (s8 === 0) {
            cell.style.color = "rgb(26, 141, 234)";
            }
            }
        } else if (x === 5) { 
            cell.textContent = "";
        } else if (x === 6) { 
            cell.textContent = "";
        } else if (x === 7) { 
            cell.textContent = "";
        } else if (x === 8) { 
            cell.textContent = "";
        } else if (x === 9) {
            button.type = "button";
            var newId = generateUniqueMirrorID();
            //button.id = `deleteItem-${newId}`; //////
            button.id = `${newId}`;
            button.value = "  DELETE ITEM  ";
            button.dataset.mirrorID = newId;
            //button.dataset.mode = 1; //////
            button.dataset.mode = 2;
           
            //button.dataset.rowIndex = r + 3;
            //console.log("BUTTON Row, actually r + 3", r + 3)  
            button.addEventListener("click", function() {
            deleteTableRow(button, currentTable);
            });
            cell.appendChild(button); // not losing bindings
        }
        }
        console.log("button.id:", button.id, "mirrorID:", button.dataset.mirrorID, "Mode:", button.dataset.mode)
    
    return blankRow;
}
//function appendTable2(cells, fieldNumber, currentTable) {
function appendTable2() {
    currentTable = document.getElementById("editNoteTable");
    par = null;
    if (!(currentTable instanceof HTMLElement)) {
    console.error("currentTable is not a valid HTML element");
    return;
    }  
    if (s8 === 1) {
    r = r + 1;
    if (itemUpdate[0] !== '' && r > 0) { /////
    if (!reader[r]) {reader[r] = [];}
    //if (itemUpdate[0]) {reader[r][0] = itemUpdate[0];}}
    //if (itemUpdate[1]) {reader[r][1] = itemUpdate[1];}}
    reader[r][0] = itemUpdate[0];
    reader[r][1] = itemUpdate[1];
    }
    }
    //if (s8 === 2) { ////
    if (s8 === 2 || s8 === 4) {
    r = currentTable.rows.length - 1;
    }
    if (defaultItem !== null) {
    r = defaultItem - 1;
    }
    if (s8 === 4) {
    console.log("defaultItem", defaultItem, typeof defaultItem)
    if (!reader[r + 2]) {
    reader[r + 2] = [];
    }    
    }
    
    if (!reader[r]) { 
    reader[r] = [];
    }
    if (!reader[r + 1]) {
        reader[r + 1] = [];
    }
    
    console.log("r", r)
    if (s8 === 0) {
    //console.log("reader[r][9]", reader[r][9]) /////
    console.log("reader[r][2]", reader[r][2]) /////
    reinvestAmount = reader[r][2]; // calculate the real value if eased ///// 
    blankRow = getBlank_tr(currentTable, reader, r, reinvestAmount);
    currentTable.appendChild(blankRow);
    reader[1][2] = reinvestAmount;
    s8 = 2;
    return;
    }
    if (s8 != 0 && r > 0) {
    if (itemNumber >= clientItems1.length) {   
    console.log("Initializing Line Item")
    console.log("Latent Value:", reader[r][2])
    console.log("Reader Index:", r)
    //reader[r][0] = Number(new Date().getTime());
    reader[r][0] = String(new Date().getTime());
    //itemUpdate[0] = '';
    itemUpdate[0] = reader[r][0];
    reader[r][1] = "Pending"; /////
    itemUpdate[1] = ''; 
    }
    }
    var sectionAChecked = Array.from(document.getElementsByClassName("section1")).some(checkbox => checkbox.checked);
    if (sectionAChecked === true) { 
    Array.from(document.getElementsByClassName("section1")).forEach(checkbox => checkbox.checked = false);  
    }
    //document.getElementById("newInvestAmount").value = "";
    const input = document.getElementById("newInvestAmount");
    //input.value = input.value !== null ? input.value : "";
    if (input) {
    input.value = "";
    }
    if (errorMessageElement) {
    errorMessageElement.innerHTML = "";
    }
    //errorMessageElement.innerHTML = "<div id='editError' class='editError'><fieldset>" + errorMessages + "</fieldset></div>";
    var sectionBChecked = Array.from(document.getElementsByClassName("section2")).some(checkbox => checkbox.checked);
    if (sectionBChecked === true) { 
    Array.from(document.getElementsByClassName("section2")).forEach(checkbox => checkbox.checked = false);
    }
   console.log("**********************************************************************APPENDTABLE2-- WORKING ON ROW:", r+1, typeof r)
    console.log("itemUpdate", itemUpdate)
    for (let i = 0; i < currentTable.rows.length; i++) {
        console.log("Reader Element:",i, reader[i]);
    }

    let reinvestData = document.createElement("tr");
    let cell;
    for (let x = 0; x < 11; x++) {
        //if (x === 1 && s3 === 1 && s8 != 0) continue;
        cell = createRecords(x);
        if (x === 0 && s3 === 1 && s8 != 0) {
        cell = document.createElement("td");
        cell.colSpan = 2;
        cell.textContent = "Reinvestment Amount";
        cell.style.textAlign = "center";
        cell.style.fontWeight = "bold";
        cell.classList.add("twoLineCell");
        }
        if (x === 1) {
        cell = document.createElement("td");
        cell.textContent = ""; //"\u00A0"
        cell.style.textAlign = "center";
        cell.style.fontWeight = "normal";
        }
        if (x === 2) {
            console.log("itemUpdate[x]", itemUpdate[x])
            if (itemUpdate[0]) {
            console.log("2A")
            if (s8 === 2) {
                console.log("2B")
                console.log("reader[r][x]", reader[r][x])
                if (itemUpdate[7].substring(0, 2) === "A2") {
                cell.textContent = "Closed";
                itemUpdate[6] = " - ";
                itemUpdate[8] = " - ";
                if (reader[r - 2][7]?.substring(0, 2) !== "A1") { //////////////////
                //reader[r - 1][9] = getString(0); //// /
                console.log("reader[r - 2][x]", reader[r - 2][x])
                } else {
                console.log("reader[r][x]", reader[r][x])   
                }
                } else {
                console.log("2D")
                console.log("r =", r)
                console.log("reader[r][2]",reader[r][2])
                console.log("reader[r+1][2]",reader[r+1][2])
                console.log("reader[r][9]",reader[r][9])
                console.log("reinvestAmount", reinvestAmount)
                console.log("reinvestmentAmountAdjustment",reinvestmentAmountAdjustment)
                console.log("paymentAdjustment",paymentAdjustment)
                console.log("itemUpdate[x]", itemUpdate[x])
                if (itemUpdate[7].substring(0, 2) === "A1") {
                reader[r + 1][x] = itemUpdate[x];
                console.log("at A1: ", reader[r + 1][x], currentTable?.rows[r + 2]?.cells[1]?.innerText)
                if (currentTable.rows[r + 2]?.cells[1]) { currentTable.rows[r + 2].cells[1].innerText = itemUpdate[x]; }
                cell.textContent = reader[r][x];
                reinvestAmount = itemUpdate[x];  
                } else if (itemUpdate[7].substring(0, 2) === "A4") {
                reader[r + 1][x] = itemUpdate[x];
                console.log("at A4: ", reader[r + 1][x], currentTable?.rows[r + 2]?.cells[1]?.innerText);
                if (currentTable.rows[r + 2]?.cells[1]) { currentTable.rows[r + 2].cells[1].innerText = itemUpdate[x]; }
                cell.textContent = reader[r][x];
                reinvestAmount = itemUpdate[x];  
                } else if (itemUpdate[7].substring(0, 2) === "A3") {
                // currentTable.rows[r + 1].cells[1].innerText = itemUpdate[x + 6];
                reader[r + 1][x] = itemUpdate[x];
                console.log("at A3: ", reader[r + 1][x], currentTable?.rows[r + 2]?.cells[1]?.innerText)
                if (currentTable.rows[r + 2]?.cells[1]) { currentTable.rows[r + 2].cells[1].innerText = itemUpdate[x]; }
                cell.textContent = reader[r][x];
                reinvestAmount = itemUpdate[x];   
                }
                } 
                //console.log("2F")
                } else if (s8 === 1) {    
            console.log("2G")
            if (itemUpdate[7].substring(0, 2) === "A2") {
            cell.textContent = "Closed";
            reader[r][x] = itemUpdate[x]; //// /   
            } else {
            reader[r][x] = itemUpdate[x];
            cell.textContent = reader[r][x];
            reinvestAmount = itemUpdate[x];
            }
            } else if (s8 === 4) {
            console.log("2H")
            if (itemUpdate[7].substring(0, 2) !== "A2") {
            console.log("r =", r)
            console.log("reader[r + 1][2]",reader[r + 1][2])
            console.log("reader[r + 2][2]",reader[r + 2][2])
            console.log("itemUpdate[x]", itemUpdate[x])
            reinvestAmount = itemUpdate[x];
            cell.textContent = reader[r][x];
            if (itemUpdate[7].substring(0, 2) === "A1") { 
                console.log("at s84 A1: ", reader[r + 1][x], currentTable?.rows[r + 2]?.cells[1]?.innerText)
            currentTable.rows[r + 2].cells[1].innerText = itemUpdate[x];
            reader[r + 1][x] = itemUpdate[x];
            cell.textContent = reader[r][x];
            } else if (itemUpdate[7].substring(0, 2) === "A4" && currentTable.rows[r + 2].cells[1].innerText === "") {
                console.log("at s84 A4: ", reader[r + 1][x], currentTable?.rows[r + 2]?.cells[1]?.innerText)
            currentTable.rows[r + 2].cells[1].innerText = getString(getNumber(itemUpdate[x + 6]) - getNumber(itemUpdate[x + 4]));
            reader[r + 1][x] = itemUpdate[x];
            } else if (itemUpdate[7].substring(0, 2) === "A3" && currentTable.rows[r + 2].cells[1].innerText === "") {
                console.log("at s84 A3: ", reader[r + 1][x], currentTable?.rows[r + 2]?.cells[1]?.innerText)
                currentTable.rows[r + 2].cells[1].innerText = itemUpdate[x + 6];
            reader[r + 1][x] = itemUpdate[x];
            cell.textContent = reader[r][x]; 
            }}
            console.log("reader[r + 1][2]",reader[r + 1][2])
            console.log("itemUpdate[x]", itemUpdate[x])
            console.log("reinvestmentAmountAdjustment ", reinvestmentAmountAdjustment)
            console.log("paymentAdjustment", paymentAdjustment)
            console.log("cell.textContent =", reader[r][x])
            if (itemUpdate[7].substring(0, 2) === "A2") {
            cell.textContent = "Closed";
            reader[r + 1][x] = itemUpdate[x];
            itemUpdate[9] = itemUpdate[x];
            reader[r + 1][9] = itemUpdate[x];   
            }
            let button = currentTable.rows[r + 1].querySelector("input[type='button']");
            button.dataset.mode = 2;
            }
            } else {
            console.log("2I")
            cell.textContent = itemUpdate[x] ?? "";
            reader[r][x]  = itemUpdate[x] ?? "";
            }
            //console.log("itemUpdate[",x,"]", itemUpdate[x])
            //itemUpdate[x] = "";
        }
        if (x === 3) {
            if (itemUpdate[0]) {
            if (itemUpdate[7].substring(0, 2) === "A2") {
            itemUpdate[x] = " - "
            cell.textContent = itemUpdate[x];
            reader[r][x] = itemUpdate[x];   
            } else {
            cell.textContent = itemUpdate[x];
            reader[r][x] = itemUpdate[x];
            }
        } else {
            cell.textContent = itemUpdate[x] ?? "";
            reader[r][x]  = itemUpdate[x] ?? "";
            }
            //console.log("itemUpdate[",x,"]", itemUpdate[x])
            //itemUpdate[x] = "";
        } 
        if (x === 4) {
            if (itemUpdate[0]) {
            if (itemUpdate[7].substring(0, 2) === "A2") {
            itemUpdate[x] = " - "
            cell.textContent = itemUpdate[x];
            reader[r][x] = itemUpdate[x];   
            } else {
            cell.textContent = itemUpdate[x];
            reader[r][x] = itemUpdate[x];
            }
        } else {
            cell.textContent = itemUpdate[x] ?? "";
            reader[r][x]  = itemUpdate[x] ?? "";
            }
            //console.log("itemUpdate[",x,"]", itemUpdate[x])
            //itemUpdate[x] = "";
        } 
        if (x === 5) {
            //let data;
            if (itemUpdate[0]) {
            if (itemUpdate[x + 2].substring(0, 2) === "A2") {
            itemUpdate[x] = reader[r - 1][x];
            reader[r][x] = itemUpdate[x];
            cell.textContent = itemUpdate[x];
            } else if (s8 === 2 || s8 === 4) {
            //
            console.log("itemUpdate[x]", itemUpdate[x])
            console.log("itemUpdate[x-1]", itemUpdate[x - 1])
            if (!itemUpdate[x - 1]) {   
            itemUpdate[x] = "";    
            } else if (reader[r][1] === "Pending") {
                if (s8 === 2 || s8 === 4) {
                console.log("FIVE_2")
                let monthsAhead = [];
                let originDate = [];
                //for (let a = 0; a <= r - 1; a++) { /////
                for (let a = 0; a < r; a++) { /////
                    monthsAhead[a] = reader[a][x - 1];
                    originDate[a] = reader[a][x];
                    console.log("monthsAhead:",monthsAhead[a], "originDate:",originDate[a])   
                    //newOriginDate = originDate[a];
                }
                console.log("Previous stored monthsAhead:", reader[r][x - 1], "originDate:", reader[r][x])
                monthsAhead[r] = itemUpdate[x - 1];
                originDate[r] = itemUpdate[x]; ////////
                console.log("r", r)
                console.log("Current array monthsAhead:", monthsAhead[r], "originDate:", originDate[r])
                console.log("monthsAhead:",monthsAhead, "originDate:",originDate)
                console.log("itemUpdate[x-1]",itemUpdate[x-1])
            let tEnd = indefinite(monthsAhead, originDate, itemUpdate[x - 1]);
            let formT = tEnd.toLocaleDateString("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "numeric"
            });
            console.log("tEnd", tEnd, typeof tEnd)
            console.log("formT", formT, typeof formT)
            //reader[r][x] = "(Indefinite)" + " " + formT;
            reader[r][x] = String(formT) + " " + "(Indefinite)";
            cell.textContent = reader[r][x];
            monthsAhead = []; /////
            originDate = []; /////
            }
            } else {
                cell.textContent = itemUpdate[x];
                reader[r][x] = itemUpdate[x];
                } 
            } else {
            cell.textContent = itemUpdate[x];
            reader[r][x] = itemUpdate[x];
            }
        } else {
            cell.textContent = itemUpdate[x] ?? "";
            reader[r][x]  = itemUpdate[x] ?? "";
            }
            //console.log("itemUpdate[",x,"]", itemUpdate[x])
            //itemUpdate[x] = "";
        }
        if (x === 6) {
            if (itemUpdate[0]) {
            if (Array.isArray(itemUpdate[x])) {
            itemUpdate[x] = String(itemUpdate[x]);
            reader[r][x] = itemUpdate[x];
            }
            if (itemUpdate[7].substring(0, 2) === "A2") {
            itemUpdate[x] = " - "
            cell.textContent = itemUpdate[x];
            reader[r][x] = itemUpdate[x];   
            } else {
                console.log("6")
            cell.textContent = itemUpdate[x];
            reader[r][x] = itemUpdate[x];
            }
        } else {
            cell.textContent = itemUpdate[x] ?? "";
            reader[r][x]  = itemUpdate[x] ?? "";
            }
            //console.log("itemUpdate[",x,"]", itemUpdate[x])
            //itemUpdate[x] = "";
        }
        if (x === 7) { 
        //let updateRow = currentTable.rows[r];
        //let codeUpdate = updateRow.cells[x];

        if (itemUpdate[0]) {
        if (itemUpdate[7].substring(0, 2) === "A2") {
        cell.textContent = itemUpdate[x];
        reader[r][x] = itemUpdate[x];
        } else {
        console.log("7")
        cell.textContent = itemUpdate[x] ?? "";
        reader[r][x]  = itemUpdate[x] ?? "";     
        }
        // rewrite for r === 0
        //console.log("r:", r, "updateRow", reader[(r-1)][x], "to", itemUpdate[x])
        if (r === 1 && s2 === 1 && s8 === 5) { 
            codeUpdate.style.color = "rgb(26, 141, 234)";
            codeUpdate.textContent = itemUpdate[x];
            } else if (r > 1) {
            //codeUpdate = updateRow.cells[x - 1];
            //codeUpdate.style.color = "rgb(0, 0, 0)";
            //codeUpdate.style.color = "rgb(26, 141, 234)";
            //codeUpdate.textContent = itemUpdate[x];
            }
        } else {
            cell.textContent = itemUpdate[x] ?? "";
            reader[r][x]  = itemUpdate[x] ?? "";
            }
            //console.log("itemUpdate[",x,"]", itemUpdate[x])
            //itemUpdate[x] = "";
        }
        if (x === 8) {
            if (itemUpdate[0]) {
            if (Array.isArray(itemUpdate[x])) {
            itemUpdate[x] = String(itemUpdate[x]);
            }
            if (itemUpdate[7].substring(0, 2) === "A2") {
            itemUpdate[x] = " - "
            cell.textContent = itemUpdate[x];
            reader[r][x] = itemUpdate[x];  
            } else {
                console.log("8")
            cell.textContent = itemUpdate[x];
            reader[r][x] = itemUpdate[x];
            }
        } else {
            cell.textContent = itemUpdate[x] ?? "";
            reader[r][x]  = itemUpdate[x] ?? "";
            }
            //console.log("itemUpdate[",x,"]", itemUpdate[x])
            // itemUpdate[x] = "";
        }
        if (x === 9) {
            if (itemUpdate[0]) {
            if (Array.isArray(itemUpdate[x])) {
            itemUpdate[x] = String(itemUpdate[x]); 
            }
            cell.textContent = itemUpdate[x];
            reader[r][x] = itemUpdate[x];
            if (itemUpdate[7].substring(0, 2) === "A2") {
            cell.textContent = itemUpdate[x];
            reader[r][x] = itemUpdate[x];  
            }
        } else {
            cell.textContent = itemUpdate[x] ?? "";
            reader[r][x]  = itemUpdate[x] ?? "";
            }
            //console.log("itemUpdate[",x,"]", itemUpdate[x])
            //itemUpdate[x] = "";
        }
        if (x === 10) {
            itemUpdate[11] = record[0]; // id
            itemUpdate[13] = "Pending"; // oe  ///////////////// verify functionality
            if (s8 === 4) {
            button = currentTable.rows[r + 1].querySelector("input[type='button']");
            button.dataset.mode = 2; ////////////////// undefined when button is deleted
            cell.appendChild(button);
            } else {
            //cell = document.createElement("td");
            //cell.style.textAlign = "center";
            let button = document.createElement("input");
            button.type = "button";
            //button.id = `deleteItem-${r}`;
            var newId = generateUniqueMirrorID();
            button.id = `deleteItem-${newId}`;
            button.value = "  DELETE ITEM  ";
            button.dataset.mirrorID = newId;
            button.dataset.mode = 2;
            console.log("Button is Initialized")
            //button.dataset.rowIndex = r + 1; // original r
            button.dataset.rowIndex = r;
            console.log("button.id:", button.id, "mirrorID:", button.dataset.mirrorID, "Mode:", button.dataset.mode)
            button.addEventListener("click", function() {
            clearDisplay();
            deleteTableRow(button, currentTable);
            });
            cell.appendChild(button);
        }
        }
        if (x !== 1 && x !== 11) { // adding one
        //if (x > 1) { // adding one
            if (cell) {
            reinvestData.appendChild(cell);
            }
        } 
    } // loop end
    console.log("s8 out:", s8)
    console.log("Reader out:", reader)
    if (s8 === 5) {
    //r = r + 1;
    } 
    if (s8 === 2 || s8 === 4) {
    console.log("reinvestData", reinvestData)
    if (currentTable.rows[r + 1]) {
    currentTable.deleteRow(r + 1);
    console.log("Inserting row");
    let newRow = currentTable.insertRow(r + 1);
    let clonedRow = reinvestData.cloneNode(true);
    Array.from(clonedRow.cells).forEach((cell, index) => {
    newRow.appendChild(cell.cloneNode(true));
    });
    let buttonCell = newRow.cells[9];
    let originalButton = buttonCell?.querySelector("input[type='button']");
    if (originalButton) {
    const clonedButton = originalButton.cloneNode(true);
    clonedButton.addEventListener("click", () => deleteTableRow(clonedButton, currentTable));
    buttonCell.replaceChild(clonedButton, originalButton); // swap old for newly bound
    }
    //if (itemUpdate[7].substring(0, 2) === "A1" && r > 0) { ///// redundant
    //console.log("CURRENTTABLEROWS[R+2].CELLS[1].innerText", currentTable.rows[r+2].cells[1].innerText)
    //currentTable.rows[r + 2].cells[1].innerText = reader[r + 1][2];
    //}
    //console.log("VERIFY THIS VALUE", currentTable.rows[r + 1].cells[1])
    //currentTable.rows[r + 1].cells[1].innerText = reader[r][2];
    console.log(r, "itemUpdate[x]", itemUpdate[x], x)
    if (currentTable.rows.length === 1) {}
    if (currentTable.rows.length >= 2) {
    //if (reader[r][7].substring(0, 2) !== "A2" && r + 2 === currentTable.rows.length) {
    if (reader[r][7].substring(0, 2) !== "A2" && r + 2 === currentTable.rows.length) {        
        console.log("Appending row")
        console.log("r + 2:", r + 2, "currentTable.rows.length", currentTable.rows.length)
    //reinvestAmount = reader[r + 1][2];
    //console.log("reader[r+1][2]",reader[r+1][2])
    //console.log("reader[r+1][0]",reader[r+1][0])
    //console.log("Last Entry:", reinvestAmount)
    //console.log("Previous Initialization:", reader[r+1][0])
    blankRow = getBlank_tr(currentTable, reader, r, reinvestAmount);
    console.log("WRITING BLANK ROW")
    currentTable.appendChild(blankRow);
    }
    }
    }
    if (paymentAdjustment) {
    paymentAdjustments()
    }
    if (reinvestmentAmountAdjustment) {
    console.log("WRITING:", getString(reinvestmentAmountAdjustment));
    reinvestmentAmountAdjustments();    
    }
    } else {
    //reinvestAmount = reader[r + 1][2];
    currentTable.appendChild(reinvestData);
    //reader[r + 1][0] = Number(new Date().getTime());
    console.log("Writing Database Record")
    //console.log("Last Entry:", reinvestAmount)
    //console.log("Previous Initialization:", reader[r+1][0])
    console.log("currentTableRows.length", currentTable.rows.length)
    console.log("r + 2", r + 2)
    console.log("s8:", s8)
    if (s8 === 1 && r + 2 === currentTable.rows.length) {
    console.log("r3", r)
    }
    console.log("s8", s8)
    console.log("____________________________________");
    }
    reinvestAmount = ""; //// /
    //defaultItem = setDefault();
    console.log("DEFAULTITEM_2", defaultItem)
    if (s8 === 2) {
    setTimeout(() => {   
    }, 20);
    recalculateTable(startIndex = null);
    editInvestment(defaultItem);
    } 
    if (s8 === 4) {
        setTimeout(() => {   
        }, 20);
        console.log("DEFAULTITEM_A", defaultItem)
        recalculateTable(startIndex = defaultItem);
        editInvestment(defaultItem);
        s8 = 2; //// /
    }
    if (s8 === 1 && r + 1 === currentTable.rows.length) {
    s8 = 2;
    }
}
function submitChanges() {
    var sectionAChecked = Array.from(document.getElementsByClassName("section1")).map(checkbox => checkbox.checked);
    var sectionBChecked = Array.from(document.getElementsByClassName("section2")).some(checkbox => checkbox.checked);
    if (s31 === 1) { 
        return;
    }
    if (sectionAChecked[1] && sectionBChecked === false) {
    s31 = 0;
    // debug
    //itemUpdate[3] = "-", itemUpdate[4] = "-", itemUpdate[5] = "", itemUpdate[6] = clientItems[6], itemUpdate[8] = clientItems[8], itemUpdate[9] = clientItems[9];
    //itemUpdate[3] = "-", itemUpdate[4] = "-";
    } else {
    if (!(sectionAChecked.some(Boolean) && sectionBChecked)){
    return;
    }
    }
    n = 1;
    s2 = 1;
    s3 = 1;
    console.log("ItemUpdate7", itemUpdate[7])
    assembleString1();
    console.log("ItemUpdate7", itemUpdate[7])
    limits[n] = processString(itemUpdate[7]);
    console.log("trm", trm)
    //itemNumber++;
    console.log("itemUpdate_A", itemUpdate)
    //clientItems = itemUpdate;
    makeTable();
    s2 = 0;
}
function generateUniqueMirrorID() {
    window.uniqueCounter = window.uniqueCounter || 0;
    const timestamp = Date.now();
    uniqueCounter += 1;
    return `${timestamp}-${uniqueCounter}`;
}
function getRowOneLastCell() {
    const rowOne = currentTable.rows[1];
    return rowOne.cells[rowOne.cells.length - 1];
}
function removeDeleteNoteButton() {
    const existing = document.querySelector("input[id^='isNote-']");
    if (existing) {
        existing.remove();
        console.log("DELETE NOTE button removed");
    }
}
function handleDeleteNoteClick(event) {
    const btn = event.target;
    if (record[1] !== "Pending" && record[1] !== "Deleted") {
        document.getElementById('message').innerText =
            "Active Notes Cannot be Deleted From the Register";
        return;
    }
    btn.disabled = true;
    btn.value = "DELETING...";
    reader[0][1] = "Deleted";
    reader[1][0] = "";
    reader[1][1] = "";
    reader[1][2] = "";
    editNote();
    btn.value = " Deleted  ✓ ";
    btn.classList.add("saved-pulse");
    setTimeout(() => btn.classList.remove("saved-pulse"), 800);
    setTimeout(() => {
        removeDeleteNoteButton();
    }, 1200);
    button1 = document.getElementById("updateNoteEdit");
    button1.classList.add("delete-mode");
    button1 = "DELETED NOTE";
    itemControlButton.value = button1;
    itemControlButton.disabled = true;
}
function clearDisplay() {
    console.log("clearDisplay at", defaultItem)
    if (currentTable.rows[defaultItem]) {
    const row = document.getElementById("editNoteTable")?.rows[defaultItem];
    const cell = row.cells[1];
    const cellValue = cell.innerText.trim();
    cell.style.backgroundColor = "";
    cell.style.outline = "";
    cell.style.borderRadius = "";
    cell.innerText = cellValue;
    const currentCell = row.cells[0];
    currentCell.style.color = "rgb(0, 0, 0)";
    currentCell.innerText = "Reinvestment Amount";
    currentCell.classList.add("twoLineCell");  
    }
}
function setDefault() {
    clearDisplay();
    console.log("At setDefault: reader[r][2]", reader[r][2]);
    console.log("At setDefault: reader[r][9]", reader[r][9]);
    console.log("Current default", defaultItem)
    console.log("reader[r+1][2]",reader[r + 1][2])
            console.log("reader[r][9]",reader[r][9])
            console.log("reinvestAmount", reinvestAmount)
currentTable = document.getElementById("editNoteTable");
if (defaultItem !== null) {
    let currentCell;
    if (currentTable.rows[defaultItem]) {
    currentCell = currentTable.rows[defaultItem].cells[0];
    currentReinvestmentCell = currentTable.rows[defaultItem].cells[1]; /////
    console.log("currentTable.rows[defaultItem].cells[1]", currentTable.rows[defaultItem].cells[1])
    currentCell.style.color = "rgb(0, 0, 0)";
    currentCell.innerText = "Reinvestment Amount";
    currentCell.classList.add("twoLineCell");
}
defaultItem = null;  
} 
for (let i = 2; i < currentTable.rows.length - 1; i++) { //// / i = 1? ////////////////
    console.log("Row", i, "Cell[3]:", currentTable.rows[i]?.cells[3]?.textContent);
    if (currentTable.rows[i].cells[2].innerText === "" || currentTable.rows[i].cells[6].innerText?.substring(0, 2) === "A2") {
    if (!defaultItem) {
    defaultItem = i;
    itemUpdate[2] = reader[i - 1][2];
    if (reader[i][3] === "") {
    // reader[i][2] = ""; ///////////////////// //// /
    currentTable.rows[i + 1].cells[1].innerText = reader[i][2];
    }
    for (var o = 0; o < 10; o++) {
    if (o < 3) {
    itemUpdate[o] = reader[i - 1][o]
    } else {
    itemUpdate[o] = ""; 
    }
    }
    //i = currentTable.rows.length /////
    }
    } else {
        //defaultItem = currentTable.rows.length - 1 /////
    }
    /*
    let button = document.createElement("input");
    button.type = "button";
    var newId = generateUniqueMirrorID();
    button.id = `deleteItem-${newId}`;
    button.value = "DELETE ITEM";
    button.dataset.mirrorID = newId;
    button.dataset.mode = 1;
    //button.dataset.rowIndex = i; /////
    button.dataset.rowIndex = defaultItem;
    */
} 
console.log("READER", reader)
console.log("itemUpdate", itemUpdate)
console.log("itemUpdate[2]", itemUpdate[2])
console.log("defaultItem", defaultItem)
if (defaultItem !== null && defaultItem !== currentTable.rows.length - 1) {
if (currentTable.rows[defaultItem]) {
console.log("Setting for defaultItem")
let currentCell = currentTable.rows[defaultItem].cells[0];
currentCell.style.color = "rgb(26, 141, 234)";
if (currentTable.rows[defaultItem].cells[6].innerText.substring(0,2) === "A2") {
currentCell.innerText = "Reinvestment or Closing Balance";   
} else {
currentCell.innerText = "Reinvestment or Current Balance";
}
currentCell.classList.add("twoLineCell");
r = defaultItem - 1;
console.log("At setDefault before leaving: reader[r][2]", reader[r][2]);
console.log("At setDefault: reader[r][9]", reader[r][9]);
console.log("r + 1: cell2 reader",reader[r+1][2])
            console.log("Previous payout value",reader[r-1][9])
            console.log("reinvestAmount", reinvestAmount)
itemUpdate[2] = currentTable.rows[defaultItem].cells[1].innerText;
s8 = 2;
}
// needs alt case //// /
} else if (defaultItem === currentTable.rows.length - 1) {
r = defaultItem - 1;
console.log("At setDefault before leaving: reader[r][2]", reader[r][2]);
console.log("At setDefault: reader[r][9]", reader[r][9]);
itemUpdate[2] = currentTable.rows[defaultItem].cells[1].innerText;
s8 = 4;
}
if (defaultItem === null) {
console.log("Setting for null defaultItem")
defaultItem = currentTable.rows.length - 1;
r = defaultItem - 1;
if (currentTable.rows[defaultItem]) {
let currentCell = currentTable.rows[defaultItem].cells[0];
currentCell.style.color = "rgb(26, 141, 234)";
if (currentTable.rows[defaultItem].cells[6].innerText.substring(0,2) === "A2") {
currentCell.innerText = "Reinvestment or Closing Balance";   
} else {
currentCell.innerText = "Reinvestment or Current Balance";
}
currentCell.classList.add("twoLineCell");
itemUpdate[2] = currentTable.rows[defaultItem].cells[1].innerText;
console.log("itemUpdate[2] trace", itemUpdate[2])
r = defaultItem - 1;
}
s8 = 2;
}
if (defaultItem === 2 && record[1] === "Pending") {
    createDeleteNoteButton(r);
} else {
    removeDeleteNoteButton();
}
return defaultItem;
}
function createDeleteNoteButton(rowIndex) {
    removeDeleteNoteButton();
    const cell = getRowOneLastCell();
    const btn = document.createElement("input");
    btn.type = "button";
    const newId = generateUniqueMirrorID();
    btn.id = `isNote-${newId}`;
    btn.value = "  DELETE NOTE  ";
    btn.dataset.mirrorID = newId;
    btn.dataset.rowIndex = rowIndex;
    btn.dataset.mode = 2;
    btn.classList.add("delete-mode");
    btn.addEventListener("click", handleDeleteNoteClick);
    cell.prepend(btn);
    console.log("DELETE NOTE button created:", btn.id);
}

/*
function addDeleteButtonListeners() {
    let buttons = document.querySelectorAll("#editNoteTable tr:not(:first-child) input[type='button']");
    buttons.forEach(button => {
    button.removeEventListener("click", handleDeleteButtonClick);
    button.addEventListener("click", renumberRows);
    });
}
 */
function clearData(rowNumber) {
    for (let o = 2; o < 9; o++) {
    currentTable.rows[rowNumber].cells[o].textContent = "";
    //console.log("Cleared Data:",reader[r][o + 1] )
    reader[r][o + 1] = "";
    itemUpdate[o + 1] = "";
    }
    reader[r][0] = String(new Date().getTime());
}
function getValue1(investingAmount) {
    if (investingAmount === "A2") {
    reader[r][2] = getString("0");
    } else if (investingAmount === "A1") {
        reader[r][2] = defaultItem2[r + 1];
    } else if (investingAmount === "A3") {
        reader[r][2] = reader[r - 1][8];
    } else {
        //reader[r][2] = getString(getNumber(reader[r - 1][8]) - getNumber(reader[r - 1][2]));
        reader[r][2] = reader[r - 1][2];
    }
}
function renumberRows(button, currentTable) {
    if (!currentTable) {
    console.error("Table with ID 'currentTable' not found.");
    return;
    }
    console.group("renumberRows Debugging");
    let rows = currentTable.rows;
    console.log("Total rows in table:", rows.length);
    let buttonMirror = button.dataset.mirrorID;
    console.log("Button's dataset.mirrorID (buttonMirror):", buttonMirror);
    console.log("button.id:", button.id, "mirrorID:", button.dataset.mirrorID, "Mode:", button.dataset.mode)
    let rowNumber;
    console.log("Iterating over rows:");
    for (let i = 0; i < rows.length; i++) {
    console.group(`Row ${i}`);
    //console.log("Row HTML:", rows[i].outerHTML);
    // Check if the row is to be processed (skip first two rows)
    if (i > 0) {
    let inputButton = rows[i].querySelector("input[type='button']");
    if (inputButton) {
    //console.log("Found a button in this row. Button dataset.rowIndex:", inputButton.dataset.rowIndex);
    if (inputButton.dataset.mirrorID == buttonMirror) {
    rowNumber = i; // Adjust index as per your logic
    console.log("Match found! Setting rowNumber to:", rowNumber);
    console.log("button.id:", button.id, "mirrorID:", button.dataset.mirrorID, "Mode:", button.dataset.mode)
    } else {
    console.log("No match for buttonMirror in this row.");
    }
    } else {
    console.log("No button found in this row.");
    }
    } else {
    console.log("Skipping this row (heading or excluded button).");
    }
    console.groupEnd();
    }
    console.log("Final computed rowNumber:", rowNumber);
    console.groupEnd();
    if (!rowNumber) {
        rowNumber = currentTable.rows.length - 1;
    }
    return rowNumber;
}
function deleteTableRow(button, currentTable) {
    currentTable = document.getElementById("editNoteTable");
    console.log("READER AT DELETE", reader)
    //console.log("reader[rowNumber - 1][1]", reader[rowNumber - 1][1])
    console.log("1. button.dataset.mirrorID", button.dataset.mirrorID)
    console.log("1A. button.dataset.mode", button.dataset.mode)
    let rowNumber = renumberRows(button, currentTable);
    let editMode = 1;
    console.log("WORKING WITH ROW NUMBER", rowNumber)
    console.log("button.id:", button.id, "mirrorID:", button.dataset.mirrorID, "Mode:", button.dataset.mode)
    console.log("2. button.dataset.mirrorID", button.dataset.mirrorID)
    console.log("2A. button.dataset.mode", button.dataset.mode)
    console.log("S8 Value", s8)
    let rows = currentTable.rows;
    let reader2 = [];
    if (currentTable.rows[rowNumber].cells[3].innerText === "") { ////
    button.dataset.mode = 1;
    console.log("Mode Change to 1", typeof button.dataset.mode)
    }
    console.log("****Type of button.dataset.mode", typeof button.dataset.mode)
    if (rowNumber === rows.length - 1 && reader[rowNumber - 1][1] === "Pending") {
        console.log("REVALUE ROW NUMBER", rowNumber)
        console.log("reader[rowNumber - 1][2]", reader[rowNumber - 2][0], reader[rowNumber - 1][2]) //// /
        r = rowNumber - 1;
        clearData(rowNumber);
        button.dataset.mode = 1;
        //currentTable = document.getElementById("editNoteTable");
        //blankRow = getBlank_tr(currentTable, reader, r, reinvestAmount);
        //currentTable.insertRow(blankRow);
        currentTable.rows[rowNumber].cells[1].innerText = reader[r][2];
        // rows = currentTable.rows; //// /
        s8 = 4;
    } else if (rowNumber < currentTable.rows.length - 1 && button.dataset.mode === "1") {
        console.log("DELETING ROW NUMBER", rowNumber)
        if (rowNumber > 1 && reader[rowNumber - 1][1] === "Pending") {
            console.log("reader[rowNumber - 1][2]", reader[rowNumber - 2][0], reader[rowNumber - 1][2]) //// /
        if (button.dataset.mode === "1") {
        console.log("DELETING ROW NUMBER", rowNumber)
        r = rowNumber - 1;
        currentTable.deleteRow(rowNumber);
        reader[r] = [];
        r = rowNumber - 1;
        editMode = 0;
        currentTable = document.getElementById("editNoteTable");
        rows = currentTable.rows; //// /
        }
        } else if (rowNumber === 2 && record[1] === "Pending" ) {
        }
    } else if (rowNumber < currentTable.rows.length - 1 && button.dataset.mode === "2") {
        console.log("CLEARING ROW NUMBER", rowNumber)
        if (rowNumber > 1 && reader[rowNumber - 1][1] === "Pending") {
            console.log("reader[rowNumber - 1][2]", reader[rowNumber - 2][0], reader[rowNumber - 1][2]) //// /
        r = rowNumber - 1;
        // Soft Reset
        //for (let i = 0; i < reader[r].length; i++) {
        //    reader[r][i] = "";
        //  }
        console.log("reader[r][2]:", reader[r][2])
        clearData(rowNumber);
        button.dataset.mode = 1;
        if (currentTable?.rows[r + 1] && reader[r + 1][3] === "") {
        currentTable.rows[r + 2].cells[1].innerText = "";
        reader[r + 1][2] = "";
        }
        //investingAmount = reader[r - 1][7].substring(0, 2);
        //getValue1(investingAmount);
        currentTable.rows[rowNumber].cells[1].innerText = reader[r][2];
        rows = currentTable.rows;
        console.log("READ", reader)
        s8 = 2;
        }
    }

    console.log("READER AFTER DELETE", reader)
    console.log("s8:", s8)
    console.log("button.dataset.mode", button.dataset.mode)
    if (editMode === 0) {
        console.log("WORKING")
        let x = 0;
    for (let i = 0; i < reader.length -1; i++) {
    if (reader[i].length !== 0 && x === 0) {
        console.log("<", reader[i])
    reader2[i] = reader[i];
    } else if (i + 1 <= reader.length) {
        x = 1;
        console.log(">", reader[i])
    reader2[i] = reader[i + 1];
    }      
    }
    console.log("reader2", reader2)
    console.log("reader", reader)
    reader = [...reader2];
    }
    editMode = 1;
    console.log("Updated reader", reader)
    console.log("r", r)
    console.log("reader[r][2]", reader[r][2])
    console.log("S8 =", s8)
    console.log("itemUpdate", itemUpdate)
    recalculateTable(startIndex = null);
    defaultItem = setDefault();
    editInvestment(defaultItem);
    // finalizeInvestment(defaultItem); ///// /
}

function editInvestment(defaultItem) {
    console.log("at editInvestment")
    console.log("After setDefault reader[r][2]", reader[r][2]);

    const row = document.getElementById("editNoteTable").rows[defaultItem];
    const cell = row.cells[1];
    activeCell = cell;
    let input = false;
    let editTimer;
    //originalInvestmentValue = reader[defaultItem - 1][2];
    const rawCell = row.cells[1].innerText.trim();
    if (rawCell !== "Closed") {
        originalInvestmentValue = row.cells[1].innerText.trim();
    } else {
        originalInvestmentValue = reader[defaultItem - 1][2];
    }
    console.log("reader[defaultItem - 1][2]", reader[defaultItem - 1][2]);
    itemUpdate[2] = originalInvestmentValue;
    adjustedUpdateAmount = getNumber(originalInvestmentValue);
    console.log("*******************************************originalInvestmentValue:", originalInvestmentValue)
    console.log("s8:", s8, "defaultItem", defaultItem)
    
    console.log("READER", reader)
    let s8A = s8;
    hasTypedInitialDigit = false;
    //cell.style.backgroundColor = "rgba(30, 120, 70, 0.50)";
    //cell.style.backgroundColor = "rgba(40, 150, 85, 0.45)"; // nice green
    cell.style.backgroundColor = "rgba(118, 130, 94, 0.35)"; // manilla green
    //cell.style.backgroundColor = "rgba(20, 180, 90, 0.55)"; // somewhat bright green
    //cell.style.backgroundColor = "rgba(118, 130, 94, 0.50)"; // dark gray green
    //cell.style.backgroundColor = "rgba(26, 141, 234, 0.25)"; // pale green
    cell.style.outline = "2px solid rgb(26, 141, 234)";
    //cell.style.outline = "2px solid rgb(23, 141, 234)"; // doesn't match heading
    cell.style.borderRadius = "4px";
    cell.innerText = originalInvestmentValue;
    cell.setAttribute("tabindex", "0");
    cell.focus();
    cell.onkeydown = function (e) {
        const key = e.key;
        if (key === "Escape") {
            e.preventDefault();
            hasTypedInitialDigit = false;
            cell.innerText = originalInvestmentValue;
            itemUpdate[2] = originalInvestmentValue;
            reader[defaultItem - 1][2] = originalInvestmentValue;
            adjustedUpdateAmount = getNumber(originalInvestmentValue);
            console.log("Values are reset.", reader[defaultItem - 1][2])
            clearTimeout(editTimer);
            return;
        }
        

        if (["ArrowLeft", "ArrowRight", "Tab"].includes(key)) return;

        if (key === "Backspace") {
            e.preventDefault();
            cell.innerText = cell.innerText.slice(0, -1);
            hasTypedInitialDigit = true;
            return;
        }

        if (key === ".") {
            e.preventDefault();
            cell.innerText += ".";
            hasTypedInitialDigit = true;
            return;
        }

        // DIGITS
        if (/^[0-9]$/.test(key)) {
            e.preventDefault();

            if (!hasTypedInitialDigit) {
                cell.innerText = "$" + key;
                hasTypedInitialDigit = true;
            } else {
                cell.innerText += key;
            }

            clearTimeout(editTimer);
            editTimer = setTimeout(() => {
                const num = getNumber(row.cells[1].innerText);
                cell.innerText = getString(num);
                adjustedUpdateAmount = num;
                itemUpdate[2] = getString(num);
                reader[defaultItem - 1][2] = itemUpdate[2];

                console.log("CURSOR VALUES:: s8A, s8", s8A, s8);
                console.log("reader[defaultItem - 1][2]", reader[defaultItem - 1][2]);
                console.log("reader at cursor", reader)
            }, 2000);
            return;
        }
        e.preventDefault();
    };
}

function finalizeInvestment(defaultItem) {
    console.log("at finalizeInvestment", defaultItem)
    console.log("reader[r][2]", reader[r][2]);
    console.log("At finalizeInvestment: reader[r][9]", reader[r][9]);
    console.log("reader[r+1][2]",reader[r+1][2])
            console.log("reader[r][9]",reader[r][9])
            console.log("reinvestAmount", reinvestAmount)
    // console.log("reader[defaultItem - 1][2]", reader[defaultItem - 1][2]) // undefined error
    const row = document.getElementById("editNoteTable")?.rows[defaultItem];
    console.log("row", row)

    const cell = row.cells[1];
    const newValue = cell.innerText.trim();
    const num = getNumber(newValue);
    console.log("num", num)
    if (isNaN(num) || num <= 0) {
        cell.innerText = originalInvestmentValue;
        reader[defaultItem - 1][2] = originalInvestmentValue;
    } else {
        reader[defaultItem - 1][2] = getString(newValue);
    }
    // Remove highlight
    cell.style.backgroundColor = "";
    cell.style.outline = "";
    cell.style.borderRadius = "";
    activeCell = null;
    originalInvestmentValue = null;
    hasTypedInitialDigit = false;
    cell.innerText = getString(num);
    adjustedUpdateAmount = num;
    reader[defaultItem - 1][2] = getString(adjustedUpdateAmount);
}

function extractVersionFromHtml(staticHtml) { // add div id
    const match = staticHtml.match(/Version\s+([\d.]+)/i);
    return match ? match[1].trim() : null;
}

// ASCII‑normalization standard contracts
function normalizeTextA(str) {
    return str
        .replace(/[\u2018\u2019]/g, "`")
        .replace(/[\u201C\u201D]/g, '"')
        .replace(/[\u2013\u2014]/g, '-')
        .replace(/\u2026/g, '...')
        .replace(/'/g, "`");
}

function normalizeText(str) {
    return str
        .replace(/[\u2018\u2019]/g, "'")
        .replace(/[\u201C\u201D]/g, '"')
        .replace(/[\u2013\u2014]/g, '-')
        .replace(/\u2026/g, '...')
        .replace(/"/g, '\\"')
        .replace(/\r?\n/g, '')
        // remove IDE indent format
        .replace(/\s{2,}/g, ' ');
}

function validateVersion(contractA, staticHtml) {
    const formVersion = extractVersionFromHtml(staticHtml);
    if (!formVersion || formVersion !== currentVersion) return false;
    if (contractA.contractVersion && contractA.contractVersion !== currentVersion) return false;
    return true;
}

async function templateExists(version) {
    const fileName = `dataScripts_v${version.replace('.', '_')}.js`;
    const url = `/scripts/${fileName}`;
    try {
        const response = await fetch(url, { method: "HEAD" });
        return response.ok;
    } catch (err) {
        return false;
    }
}

function buildContractVersions(contractA) {
    const snapshot = {
        primaryKey: contractA.Timestamp,
        sortKey: contractA.Username,
        UUID: "",
        version: currentVersion,
        contractCode: contractA.contractCode,
        checkboxes: {},
        inputs: {}, // Stores text inputs AND the accredited_status <select>
        revealedMessage: "",
        uploadedFiles: [],
        dynamicText: {},
        images: [],
        template: `dataScripts_v${currentVersion.replace('.', '_')}.js`
    };

    document.querySelectorAll('input[type="checkbox"]').forEach(cb => {
        if (cb && cb.id) {
            snapshot.checkboxes[cb.id] = !!cb.checked;  // force boolean
        }
    });

    // TEXT INPUTS — SAFE VERSION
    // Same idea: only store values if the element exists AND has an ID.
    document.querySelectorAll(
        'input[type="text"], input[type="number"], input[type="email"], textarea'
    ).forEach(input => {
        if (input && input.id && typeof input.value === "string") {
            snapshot.inputs[input.id] = normalizeText(input.value);
        }
    });

    const accredited = document.getElementById("accredited_status");
    if (accredited) {
        snapshot.inputs["accredited_status"] = accredited.value;
    }

    const div1 = document.getElementById("divEnd1");
    const div2 = document.getElementById("divEnd2");

    if (div1 && div1.style.display !== "none") {
        snapshot.revealedMessage = normalizeText(div1.innerText.trim());
    } else if (div2 && div2.style.display !== "none") {
        snapshot.revealedMessage = normalizeText(div2.innerText.trim());
    }

    const fileListDiv = document.getElementById("fileList");
    if (fileListDiv) {
        snapshot.uploadedFiles = Array.from(
            fileListDiv.querySelectorAll("span, li, div")
        )
            .map(el => normalizeText(el.innerText.trim()))
            .filter(Boolean);
    }

    const resultA = document.getElementById("resultA");
    const termCode = document.getElementById("termCode");

    if (resultA) snapshot.dynamicText.resultA = normalizeText(resultA.innerText.trim());
    if (termCode) snapshot.dynamicText.termCode = normalizeText(termCode.innerText.trim());
console.log("**snapshot**", snapshot)
    return snapshot;
}

async function ensureJsTemplateExists(structuralTemplate) {
    console.log("at ensureJSTemplateExists")
    dataSetA[2][5] = "true";
    const action = "updateJS";
    dataSetA[0][1] = action;
    dataSetA[1][1] = "POST";
    dataSetA[2][12] = "true";
    localStorage.setItem("dataSetA", JSON.stringify(dataSetA));
    const endpoint = "https://jplbuilders-contracting.com/API/uploadImages";
    const formData = new FormData();
    formData.append("Timestamp", String(contractA.Timestamp || "")); ////////////////
    formData.append("action", "updateJS");
    formData.append("dataSetA", JSON.stringify(dataSetA));
    formData.append("version", structuralTemplate.version);
    formData.append("vector", JSON.stringify(structuralTemplate.vector));
    const requestOptions = {
        method: "POST",
        body: formData
    };
    try {
        const response = await fetch(endpoint, requestOptions);
        if (!response.ok) {
            const text = await response.text();
            console.error("updateJS failed:", response.status, text);
            return false;
        }
        return true;
    } catch (err) {
        console.error("Error during updateJS call:", err);
        return false;
    }
}

async function convertHtml(staticHtml, clonedBody) {
    if (!validateVersion(contractA, staticHtml)) {
        console.error("Version validation failed.");
        return null;
    }
    const snapshot = buildContractVersions(contractA);
    contractA.contractVersions = {
        snapshot
    };
    const structuralTemplate = mapContractStructure(clonedBody);
    console.log(structuralTemplate)
    const exists = await templateExists(currentVersion);
    if (!exists) {
        ensureJsTemplateExists(structuralTemplate);
    }
    if (snapshot) {
        console.log("snapshot exists")
    }
    return snapshot;
}

function mapContractStructure(clonedBody) {
    const vector = [];

    function addTextNode(type, node) {
        let text = normalizeText(node.innerText.trim());
        if (!text) return;

        const computed = window.getComputedStyle(node);

        vector.push({
            type,
            text,
            classList: Array.from(node.classList),
            style: {
                textAlign: node.style.textAlign || computed.textAlign || null
            }
        });
    }

    function getLabelForInput(input, root) {
        if (!input.id) return "";
        const label = root.querySelector(`label[for="${input.id}"]`);
        return label ? normalizeText(label.innerText.trim()) : "";
    }

    function getLabelForCheckbox(cb, root) {
        if (!cb.id) return "";
        const label = root.querySelector(`label[for="${cb.id}"]`);
        if (label) return normalizeText(label.innerText.trim());
        if (cb.parentElement) return normalizeText(cb.parentElement.innerText.trim());
        return "";
    }

    function walk(node) {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        const tag = node.tagName.toLowerCase();

        if (tag === "img") {
            vector.push({
                type: "image",
                id: node.id || null
            });
        }
        else if (tag === "h1" || tag === "h2" || tag === "h3") {
            addTextNode("title", node);
        }
        else if (tag === "h4" || tag === "h5" || tag === "h6") {
            addTextNode("subtitle", node);
        }
        else if (tag === "p") {
            addTextNode("paragraph", node);
        }
        else if (tag === "input") {
            const type = node.getAttribute("type") || "text";
            if (type === "checkbox") {
                vector.push({
                    type: "checkbox",
                    id: node.id || null,
                    label: getLabelForCheckbox(node, clonedBody),
                    classList: Array.from(node.parentElement?.classList || [])
                });
            } else {
                vector.push({
                    type: "input",
                    id: node.id || null,
                    label: getLabelForInput(node, clonedBody),
                    classList: Array.from(node.parentElement?.classList || [])
                });
            }
        }
        else if (tag === "textarea") {
            vector.push({
                type: "input",
                id: node.id || null,
                label: getLabelForInput(node, clonedBody),
                classList: Array.from(node.parentElement?.classList || [])
            });
        }
        
        else if (node.id === "resultA" || node.id === "termCode") {
            vector.push({ type: "dynamicText", id: node.id });
        }
        
        else if (node.id === "divEnd1" || node.id === "divEnd2") {
            const text = normalizeText(node.innerText.trim());
            if (text) {
                vector.push({
                    type: "revealedMessageTemplate",
                    id: node.id,
                    text
                });
            }
        }
        
        Array.from(node.children).forEach(walk);
    }

    walk(clonedBody);

    return {
        version: currentVersion,
        vector
    };
}

function applyContractHistoryToClone(snapshot, contractHistory) {
    Object.keys(contractHistory).forEach(field => {
        const historyArray = contractHistory[field];
        if (!Array.isArray(historyArray) || historyArray.length === 0) return;
        const lastGood = [...historyArray].reverse().find(v =>
            v !== "" && v !== null && v !== undefined
        );

        if (lastGood !== undefined) {
            if (snapshot.inputs[field] !== undefined) {
                snapshot.inputs[field] = lastGood;
            }
        }
    });
    return snapshot;
}

function reconstructContract(snapshot, container) {
    console.log("=== SNAPSHOT ===");
    console.log("revealedMessage:", snapshot.revealedMessage);
    console.log("revealedMessageId:", snapshot.revealedMessageId);
    console.log("accredited_status:", snapshot.inputs?.accredited_status);
    console.log("reconstructContract CALLED with snapshot:", snapshot);

    try {
        console.log("Contract Version:", snapshot.version);

        const tpl = window.contractTemplates?.[snapshot.version];
        if (!tpl) {
            console.error("No template for version:", snapshot.version);
            return;
        }
     
        const vector = tpl.vector;
        console.log("Vector length:", vector.length);
        const nVector = vector.filter(n =>
        !(n.type === "paragraph" && n.text?.trim().startsWith("Congratulations!"))
        );

        const messageIndex = nVector.findIndex(n => n.type === "revealedMessageTemplate");
        if (messageIndex !== -1) {
            nVector[messageIndex] = {
                type: "paragraph",
                text: snapshot.revealedMessage
            };
        }

        container.innerHTML = "";

        const logo = document.createElement("img");
        logo.id = "companyLogo";
        logo.src = "/Images/company_logo.png";
        logo.style.display = "block";
        logo.style.margin = "0 auto 10px auto";
        logo.style.width = "6.5in";
        logo.style.maxWidth = "6.5in";
        logo.style.height = "auto";
        container.appendChild(logo);

        nVector.forEach(node => {
            let el;

            switch (node.type) {
                case "title":
                    el = document.createElement("h3");
                    el.innerText = node.text;
                    break;

                case "subtitle":
                    el = document.createElement("h4");
                    el.innerText = node.text;
                    break;

                    case "paragraph": {
                        const text = node.text?.trim() || "";
                        //console.log("PARAGRAPH NODE:", node);
                    
                        if (text.startsWith("Congratulations!")) {
                            break;
                        }
                    
                        if (text.includes("The undersigned declares") &&
                            text.includes("an accredited investor")) {
                    
                            const status = snapshot.inputs?.accredited_status || "";
                            el = document.createElement("p");
                            el.innerText = `The undersigned declares ${status} an accredited investor.`;
                            break;
                        }
                
                        // DEFAULT PARAGRAPH HANDLING
                        el = document.createElement("p");
                        el.innerText = normalizeText(text);
                        break;
                    }
                    
                case "checkbox": {
                    el = document.createElement("div");
                    el.classList.add("checkbox-container");

                    const cb = document.createElement("input");
                    cb.type = "checkbox";
                    if (node.id) cb.id = node.id;
                    if (node.id && snapshot.checkboxes[node.id]) cb.checked = true;

                    const lbl = document.createElement("label");
                    if (node.id) lbl.htmlFor = node.id;
                    lbl.innerText = node.label || "";

                    el.appendChild(cb);
                    el.appendChild(lbl);
                    break;
                }

                case "input": {
                    el = document.createElement("div");
                    el.classList.add("contractFormA");
                
                    const label = document.createElement("label");
                    label.innerText = node.label || "";
                    //console.log("Input Label NODE:", node.label);
                    const input = document.createElement("input");
                    input.type = "text";
                
                    if (node.id) {
                        input.id = node.id;
                        input.value = snapshot.inputs?.[node.id] || "";
                    }
                
                    el.appendChild(label);
                    el.appendChild(input);
                    break;
                }
                

            case "dynamicText":
                if (node.id === "termCode") {
                break;
                }

    el = document.createElement("span");
    el.id = node.id;
    el.innerText = snapshot.dynamicText[node.id] || "";
    break;


                    case "revealedMessageTemplate":
                        el = document.createElement("div");
                        el.innerText = snapshot.revealedMessage || "";
                        break;
                                            
                case "image":
                    // logo + seal handled explicitly; ignore here
                    break;
            }

            if (el) {
                // restore classes from vector
                if (node.classList) {
                    node.classList.forEach(c => el.classList.add(c));
                }
                // restore alignment from vector
                if (node.style && node.style.textAlign) {
                    el.style.textAlign = node.style.textAlign;
                }
                container.appendChild(el);
            }
        });

        // Seal at very bottom, last element
        const seal = document.createElement("img");
        seal.id = "image_s";
        seal.src = "/Images/contractualSeal_e.jpg";
        seal.style.display = "block";
        seal.style.margin = "0 0 0 0";
        seal.style.width = "2.75in";
        seal.style.height = "auto";
        seal.style.float = "none"; // bottom, full-width flow
        container.appendChild(seal);

    } catch (err) {
        console.error("ERROR inside reconstructContract:", err);
    }
}

function applyComputedStylesToClone(sourceRoot, cloneRoot) {
    const sourceElements = sourceRoot.querySelectorAll("*");
    const cloneElements = cloneRoot.querySelectorAll("*");
    sourceElements.forEach((srcEl, index) => {
        const cloneEl = cloneElements[index];
        if (!cloneEl) return;
        const computed = window.getComputedStyle(srcEl);
        const style = Array.from(computed)
            .map(prop => `${prop}: ${computed.getPropertyValue(prop)};`)
            .join(" ");
        cloneEl.setAttribute("style", style);
    });
}

function collectImagesFromRoot(root) {
    return Array.from(root.querySelectorAll("img"));
}

function finalizeFormControlsInClone(root) {
    root.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        if (checkbox.checked) {
            checkbox.setAttribute("checked", "checked");
        } else {
            checkbox.removeAttribute("checked");
        }
    });

    root.querySelectorAll('input[type="text"], input[type="number"], input[type="email"], textarea').forEach(input => {
        input.setAttribute("value", input.value);
        input.style.textAlign = "left";
    });

    root.querySelectorAll("select").forEach(select => {
        const selectedValue = select.value;
        Array.from(select.options).forEach(option => {
            if (option.value === selectedValue) {
                option.setAttribute("selected", "selected");
            } else {
                option.removeAttribute("selected");
            }
        });
    });
}


function buildCombinedHtml(certificateClone, contractClone, idNumber) {
    let html = `
<!DOCTYPE html>
<html>
<head>
<title>Certificate and Contract</title>
<meta http-equiv="Content-Security-Policy" content="object-src 'none'">
<meta http-equiv="X-UA-Compatible" content="IE=edge">
<meta name="pdf" content="false">
<style>
/* ============================
   BASE LAYOUT
   ============================ */

body {
    margin: 0in;
    background-color: white;
    font-family: Tahoma;
    font-size: 12px;
}
#border.print-document {
    background-color: white;
    width: 8.5in;
    margin: 1in auto;
    padding: 0;
    overflow: visible;
}
#noteItems,
#contractContent {
    width: 6.5in;
    margin: 0 auto;
    font-size: 12px;
    line-height: 1.4;
    white-space: normal;
    word-break: keep-all;
    overflow-wrap: normal;
}

/* ============================
   PRINT (DESKTOP ONLY)
   ============================ */

@media print {

    @page {
        size: 8.5in 11in;
        margin-top: 0in;
        margin-bottom: 0in;
        margin-left: 0.75in;
        margin-right: 0.75in;
    }

    html {
        counter-reset: page 1;
    }

    html::before {
        content: "Pro Forma Capital Note Certificate and Contract — ID ${idNumber} | Page " counter(page);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        text-align: center;
        font-size: 12px;
        color: #444;
        padding-top: 0.25in;
        padding-bottom: 0.25in;
        z-index: 9999;
    }

    .page-break {
        page-break-before: always;
    }
}

/* ============================
   SCREEN SAFETY
   ============================ */
@media screen {
    html::before {
        content: none !important;
    }
}
</style>
</head>

<body>
<div id="border" class="print-document">

    <div id="noteItems">
        ${certificateClone.innerHTML}
    </div>

    <div class="page-break"></div>

    <div id="contractContent">
        ${contractClone.innerHTML}
    </div>

</div>
</body>
</html>
`;
    return html;
}



async function fetchImageAsArrayBuffer(url) {
    const response = await fetch(url);
    return await response.arrayBuffer();
}

/* ---------- HEADER: left text + right page number ---------- */


/* ---------- CERTIFICATE SECTION ---------- */
/*
function buildCertificateSection(certificateClone, logoBuffer, sealBuffer) {
    const children = [];

    // logo
    if (logoBuffer) {
        children.push(
            new Paragraph({
                children: [
                    new ImageRun({
                        data: logoBuffer,
                        transformation: {
                            width: 200, // adjust as needed
                            height: 60,
                        },
                    }),
                ],
                alignment: AlignmentType.LEFT,
            })
        );
    }

    // date (from span#today105 textContent)
    const dateNode = certificateClone.querySelector("#today105");
    if (dateNode && dateNode.textContent.trim()) {
        children.push(
            new Paragraph({
                text: dateNode.textContent.trim(),
                alignment: AlignmentType.RIGHT,
            })
        );
    }

    // title
    const headingNode = certificateClone.querySelector("#heading_w");
    if (headingNode && headingNode.textContent.trim()) {
        children.push(
            new Paragraph({
                text: headingNode.textContent.trim(),
                heading: "TITLE",
                alignment: AlignmentType.CENTER,
            })
        );
    }

    // certificate field table
    const noteDocTable = certificateClone.querySelector("#noteDocTable");
    if (noteDocTable) {
        children.push(buildCertificateFieldTable(noteDocTable));
    }

    // summary1
    const summary1 = certificateClone.querySelector("#summary1 p");
    if (summary1) {
        children.push(paragraphFromHtmlText(summary1.innerText));
    }

    // summary (main) + seal
    const summary = certificateClone.querySelector("#summaryText p");
    if (summary) {
        children.push(buildSummaryWithSeal(summary.innerText, sealBuffer));
    }

    return children;
}
*/
/* ---------- CERTIFICATE FIELD TABLE (fixed widths) ---------- */
/*
function buildCertificateFieldTable(tableNode) {
    const rows = [];
    const leftWidthTwips = inchesToTwips(2.75);
    const rightWidthTwips = inchesToTwips(3.75);

    const trNodes = tableNode.querySelectorAll("tr");
    trNodes.forEach(tr => {
        const th = tr.querySelector("th");
        const td = tr.querySelector("td");
        if (!th || !td) return;

        const label = th.textContent.trim();
        const value = td.textContent.trim();

        rows.push(
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: leftWidthTwips, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                text: label,
                                alignment: AlignmentType.LEFT,
                            }),
                        ],
                    }),
                    new TableCell({
                        width: { size: rightWidthTwips, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                text: value,
                                alignment: AlignmentType.LEFT,
                            }),
                        ],
                    }),
                ],
            })
        );
    });

    return new Table({
        width: { size: inchesToTwips(6.5), type: WidthType.DXA },
        rows,
    });
}
*/
/* ---------- SUMMARY + SEAL (floating, tight wrap-ish approximation) ---------- */
/*
function buildSummaryWithSeal(text, sealBuffer) {
    // For simplicity in docx: put text paragraph, then seal paragraph aligned right.
    // (True tight-wrap floating is more involved; this keeps it close and clean.)
    const paragraphs = [];

    paragraphs.push(paragraphFromHtmlText(text));

    if (sealBuffer) {
        paragraphs.push(
            new Paragraph({
                children: [
                    new ImageRun({
                        data: sealBuffer,
                        transformation: {
                            width: 350, // original width
                            height: 314, // original height
                        },
                    }),
                ],
                alignment: AlignmentType.RIGHT,
            })
        );
    }

    return paragraphs;
}
*/


/* ---------- HELPERS ---------- */
/*
function paragraphFromHtmlText(text) {
    return new Paragraph({
        children: [new TextRun({ text })],
        spacing: {
            after: 120, // ~Option C-ish; adjust if you want tighter/looser
        },
    });
}

function stripHtml(html) {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
}

function inchesToTwips(inches) {
    return Math.round(inches * 1440);
}
*/
function getLowerLimit(localSet) {
    if (!localSet || !localSet.trm || !localSet.version || !localSet.ContractTerms) return null;
    const { trm, version, ContractTerms } = localSet;
    const bSegment = trm.find(seg => seg.startsWith("B"));
    if (!bSegment || bSegment.length < 2) return null;
    const key = bSegment.charAt(0); // 'B'
    const index = parseInt(bSegment.slice(1), 10) - 1;
    const termObj = ContractTerms?.[version]?.[key]?.[index];
    return termObj?.lLimit ?? null;
}
function getOriginationA(readerEntry) {
    const ref = readerEntry?.[1];
    if (typeof ref === "string" && /^\d{13}$/.test(ref.trim())) {
        return new Date(Number(ref));
    }
    const fallback = readerEntry?.[0];
    return !isNaN(fallback) ? new Date(Number(fallback)) : new Date();
}
function recalculateTable(startIndex = null) {
    console.log("At recalculateTAble reader[r][2]", reader[r][2]);
    let currentTable = document.getElementById("editNoteTable");
    const redStyle = "color: red;";
    //new Date(Date.parse(serverDate)).setHours(0, 0, 0, 0);
    const getOrigination = (ref) => {
        return /^\d{13}$/.test(ref) ? new Date(Number(ref)) : new Date();
    };
    const originationRef = reader[0][1];
    let originDateRef;
    let lastMaturityDate;
    for (let i = 1; i < currentTable.rows.length; i++) {
        console.log("********************************", i, "*************************************s8:", s8)
        const row = currentTable?.rows?.[i];
        if (!row || row.nodeType !== 1 || row.tagName !== "TR") {
          console.warn(`Row ${i} is invalid or not a <tr> element`, row);
        }
        const rfs = i - 1;
        const isFirst = i === 1;
        const isLast = i === currentTable.rows.length - 1;
        const records = Array.from(row.cells).map(cell => cell?.innerText?.trim());
        console.log("RECORDS:",records)
        if (!records || records.length < 9) continue;
        const refStatus = reader[rfs][1]; 
        const isPending = refStatus === "Pending";
        const isTimestamp = /^\d{13}$/.test(refStatus);
        console.log("isTimestamp", isTimestamp, typeof isTimestamp)
        var canEdit;
        if (!isTimestamp) { 
        canEdit = isPending === true;
        console.log("canEdit", canEdit, typeof canEdit)
        } else {
            canEdit = false; // ease limit 
        }
        const userRequestedRecalc = startIndex === null || i >= startIndex;
        const termCol = isFirst ? 4 : 3;
        let term = parseInt(records[termCol], 10);
        console.log("term", term, typeof term)
        if (isNaN(term)) term = 0;
        let originDate;
        let continuity = true;
        let isBlank = false;
        let isInvalid;
        let prevLabelRaw;
        let prevLabelDate;
        let currentStoredLabel;
        const amountCol = isFirst ? 2 : 1;
        const nextAmountCol = isFirst ? 2 : 1;
        const rateCol = isFirst ? 3 : 2;
        const maturityCol = isFirst ? 5 : 4;
        const roiCol = isFirst ? 6 : 5;
        const contractCol = isFirst ? 7 : 6;
        const matureCol = isFirst ? 8 : 7;
        const payoutCol = isFirst ? 9 : 8;
        const maturityOptions = isFirst ? 7 : 6;
        const isA2Row = records[maturityOptions]?.substring(0, 2) === "A2";
        if (isFirst) {
        originDateRef = getOrigination(originationRef);
        originDate = originDateRef;
        console.log("1. originDateRef at isFirst", originDateRef) 
        continuity = true;
        if (!isPending) {
        continuity = false;
        }
        } else {
        if (i >= 1) {
        prevLabelRaw = reader[rfs]?.[5];
        prevLabelDate = new Date(prevLabelRaw?.split(" ")[0]);
        console.log("2. prevLabelDate", prevLabelDate) 
        isBlank = prevLabelRaw === "";
        isInvalid = isNaN(prevLabelDate.getTime());
        if (!isInvalid && i > 1) {
        currentStoredLabel = prevLabelDate;
        } else if (!isInvalid && i === 1) {
        currentStoredLabel = prevLabelDate; 
        } else {
        currentStoredLabel = originDateRef;
        }
        }
        }
    if (lastMaturityDate) {
    originDate = lastMaturityDate;
    } else if (currentStoredLabel) {
    originDate = currentStoredLabel;    
    }
    console.log("7. originDate", originDate)
  
        const currentMaturityLabel = row.cells?.[maturityCol]?.innerText?.trim();
        const isNullMaturity = !currentMaturityLabel || currentMaturityLabel === "";
        const isNullRow = isNullMaturity;
        let maturityCell;
        maturityCell = row.cells[maturityCol];
        let maturityDate = new Date(originDate);
        console.log("term", term, typeof term)
        maturityDate.setMonth(maturityDate.getMonth() + term);
        const formatted = maturityDate.toLocaleDateString("en-US", {
        month: "2-digit", day: "2-digit", year: "numeric"
        });
        const maturityLabel = `${formatted} (Indefinite)`;
        lastMaturityDate = maturityLabel;
        console.log("8. lastMaturityDate", lastMaturityDate)
        console.log("maturityLabel", maturityLabel)
        
        const currentLabel = maturityCell?.innerText?.trim();
        const isIndefinite = currentLabel?.includes("(Indefinite)"); 
        var currentAmountRaw = row.cells?.[amountCol]?.innerText?.trim();
        let rawAmountUpdate;
        let nextAmountUpdate;
        let nextRow;
        let nextCells;
        let rawAmount; // cell value Closed
        let nextAmount = 0;
        if (!isLast) nextRow = currentTable.rows[(i + 1)];
        if (nextRow) {
        nextCells = Array.from(nextRow.cells).map(cell => cell?.innerText?.trim());
        console.log("nextCells", nextCells);
        rawAmount = nextCells?.[1].trim();
        
        console.log("rawAmount", rawAmount)
        rawAmountUpdate = reader[rfs + 1][2];
        nextAmountUpdate = getNumber(rawAmountUpdate);
        console.log("rawAmountUpdate", rawAmountUpdate)
        }
        if (rawAmount && rawAmount !== "Closed") { ////
        nextAmount = getNumber(rawAmount);
        } else {
        if (rawAmount && rawAmount === "") { nextAmount = getString(0) }
        }
        console.log("nextAmountUpdate", nextAmountUpdate) 
        console.log("nextAmount", nextAmount)
       
        if (!isPending) {continue;}
        if (!canEdit) {
        console.log("Returning", canEdit, userRequestedRecalc)
        continue;
        }
        
        const update = (colIndex, expected, readerIndex) => {
            const isNextAmountCol = colIndex === nextAmountCol;
            let cellH;
            let rawText;
            if (!isNextAmountCol) {
            cellH = row.cells[colIndex];
            } else if (nextRow?.cells?.[colIndex]) {
            cellH = nextRow.cells[colIndex];
            }
            rawText = cellH?.innerText.trim();
            const isAmountCol = colIndex === amountCol;
            const isClosedDisplay = rawText === "Closed";
            // if (isA2Row && isAmountCol && isClosedDisplay) { //// /
            if (isA2Row && isAmountCol) { // verify corrections are inserted
            console.info(`⛔ Skipping amountCol update for A2 row ${i} (display is 'Closed')`);
            updateTable();
            return;
            }
            const display = getNumber(rawText);
            if (Math.abs(display - expected) > 0.01) {
                cellH.textContent = getString(expected);
                cellH.style.cssText = redStyle;
                if (!isNextAmountCol) {
                reader[rfs][readerIndex] = getString(expected);
                } else {
                reader[rfs + 1][readerIndex] = getString(expected);    
                }
            }
        };
        let payout = 0;
        const skipRow = isBlank;
        console.log("skipRow", skipRow)
        if (skipRow) return; // Skip rows awaiting UI reactivation
        console.log("currentLabel", currentLabel, typeof currentLabel);
        console.log("maturityLabel", maturityLabel, typeof maturityLabel);
        console.log("continuity, canEdit, isPending", continuity, canEdit, isPending);
        if (continuity && canEdit && isPending && !isBlank && currentLabel !== maturityLabel) {
        if (i !== 1) {
        maturityCell.textContent = maturityLabel;
        maturityCell.style.cssText = redStyle;
        reader[rfs][5] = maturityLabel;
        }  
        }
        if (isA2Row) {

        }
        const skipUpdate = isBlank;
        const skipAmountUpdate = isA2Row;
        if (skipUpdate) {
        //console.warn(`⚠️ Skipping payout logic for row ${i}: ${isA2Row ? "A2" : "null"} state detected`);
        console.warn(`⚠️ Completing logic at blank row ${i}`);
        continue;
        }
        if (!canEdit) {
        console.log("Returning", canEdit, userRequestedRecalc)
        continue;
        }
        if (!isPending) {continue;}
        console.log("amount from cell:", row.cells[amountCol]?.innerText?.trim());
        const rate = (row.cells?.[rateCol]?.innerText?.trim());
        console.log("16. rate:", rate, typeof rate)
        const rate_old = (row.cells[rateCol]?.innerText?.trim());
        console.log("17. rate_old:", rate_old, typeof rate_old)
        const termForCalc = (row.cells?.[termCol]?.innerText?.trim());
        const Origin = String(new Date(originDate).getTime());
        console.log("10. Origin", Origin, typeof Origin);
        if (nextCells) {
        const localSet = processString(records[contractCol]?.innerText?.trim());
        const lLimit = getLowerLimit(localSet);
        console.log("lLimit",lLimit)
        if (lLimit) {
        // if (nextAmountUpdate !== 0) { ////
        if (nextAmountUpdate) {
        if (nextAmountUpdate < lLimit) {
        nextAmountUpdate = lLimit;
        }}}
        }
        const currentAmount = getNumber(reader[rfs][2]);
        console.log("currentAmountRaw", currentAmountRaw);
        console.log("currentAmount", currentAmount);
        let concurrentAmount;
        if (currentAmountRaw !== "Closed") {
        concurrentAmount = currentAmount;
        } else {
        concurrentAmount = 0;
        }
        const Amount = String(concurrentAmount);
        const Rate = String(getNumber(rate));
        const Term = String(getNumber(termForCalc)); 
        const roi = interestCalc1(Origin, Amount, Rate, Term);
    console.log("**roi value**", roi, typeof roi )
    const matureValue = currentAmount + roi;
    if (!isBlank) {
console.log("***************************************nextAmountUpdate", nextAmountUpdate)
console.log("Record", records[contractCol])
    if (reader[rfs][7].substring(0, 2) === "A1") {
    console.log("@ A1")
    payout = matureValue - nextAmount;
    nextAmountUpdate = nextAmount; //// /
    //if ()
    
    console.log("A1 payout A1", payout)
    }

    if (reader[rfs][7]?.substring(0, 2) === "A2") {
    console.log("@ A2")
    console.log("reader[rfs - 1][9]", reader[rfs - 1][9])
    payout = getNumber(reader[rfs][2]);
    currentTable.rows[i - 1].cells[payoutCol].innerText = getString(getNumber(currentTable.rows[i - 1]?.cells[matureCol]?.innerText?.trim()) - payout);
    
    reader[rfs - 1][9] = currentTable.rows[i - 1].cells[payoutCol]?.innerText?.trim();
    console.log("reader[rfs - 1][9]", reader[rfs - 1][9])
    console.log("nextAmountUpdate:", nextAmountUpdate)
    console.log("nextAmount:", nextAmount)
    
    /*
    if (!isFirst && reader[rfs - 1][7]?.substring(0, 2) === "A1") {
    console.log("currentTable.rows[i - 1].cells[matureCol]?.innerText", currentTable.rows[i - 1]?.cells[matureCol]?.innerText?.trim(), typeof currentTable.rows[i - 1].cells[matureCol]?.innerText?.trim());
    // payout = getNumber(currentTable.rows[i - 1].cells[matureCol]?.innerText?.trim()) - getNumber(currentTable.rows[i - 1]?.cells[payoutCol]?.innerText?.trim());
    payout = getNumber(currentTable.rows[i].cells[amountCol]?.innerText?.trim());
    currentTable.rows[i - 1].cells[payoutCol].innerText = getString(getNumber(currentTable.rows[i - 1]?.cells[matureCol]?.innerText?.trim()) - payout);
    reader[rfs - 1][9] = currentTable.rows[i - 1].cells[payoutCol]?.innerText?.trim();
    console.log("A2_1 payout", payout, typeof payout)
    } else if (!isFirst && reader[rfs - 1][7].substring(0, 2) === "A3") {
    payout = getNumber(currentTable.rows[i].cells[amountCol]?.innerText?.trim());
    currentTable.rows[i - 1].cells[payoutCol].innerText = getString(getNumber(currentTable.rows[i - 1].cells[matureCol]?.innerText?.trim()) - payout);
    reader[rfs - 1][9] = currentTable.rows[i - 1].cells[payoutCol]?.innerText?.trim();
    } else if (!isFirst && reader[rfs - 1][7].substring(0, 2) === "A4") {
    payout = getNumber(currentTable.rows[i].cells[amountCol]?.innerText?.trim());
    currentTable.rows[i - 1].cells[payoutCol].innerText = getString(getNumber(currentTable.rows[i - 1].cells[matureCol]?.innerText?.trim()) - payout);
    reader[rfs - 1][9] = currentTable.rows[i - 1].cells[payoutCol]?.innerText?.trim();
    console.log("A2_4a payout", payout, typeof payout)
    }
    */
    console.log("A2_4b payout", payout, typeof payout)
    // currentTable.rows[i].cells[amountCol].innerText = "Closed"; //// /
    currentTable.rows[i].cells[1].innerText = "Closed";   
    }
    if (reader[rfs][7].substring(0, 2) === "A3") {
    console.log("@ A3")
    payout = 0;
    if (nextAmount !== matureValue) {
    nextAmountUpdate = matureValue;
    }
    if (nextAmount > matureValue) { 
    payout = matureValue - nextAmount;
    nextAmountUpdate = nextAmount;
    }
    // if (i === currentTable.rows.length - 2) { //// /  
    if (nextAmountUpdate === null && nextAmount >= 0) { //// /
    nextAmountUpdate = nextAmount; 
    }
    console.log("A3 payout", payout)
    }
    if (reader[rfs][7].substring(0, 2) === "A4") {
    console.log("@ A4")
    payout = matureValue - nextAmount;
    if (nextAmountUpdate === null && nextAmount >= 0) { //// /
    nextAmountUpdate = nextAmount; 
    }
    if (i === currentTable.rows.length - 2) { 
    }
    console.log("nextAmount", nextAmount, typeof nextAmount)
    // also reset s8 at appendTable //// /
    console.log("***nextAmountUpdate", nextAmountUpdate)    
    console.log("matureValue", matureValue, typeof matureValue)
    console.log("nextAmount", nextAmount, typeof nextAmount)
    console.log("payout A4", payout, typeof payout)
    console.log("A4 payout", payout)
    }
    update(roiCol, roi, 6);
    console.log("Updating ROI:", roi)
    if (continuity) {
    update(matureCol, matureValue, 8);
    console.log("Updating matureValue:", matureValue)
    }
    
    if (!skipUpdate) {
        update(payoutCol, payout, 9);
        console.log("Updating Payout:", payout)
        if (!isFirst) {
        if (reader[rfs - 1][7] !== "" || reader[rfs - 1][7].substring(0, 2) !== "A2") {
            if (nextAmountUpdate) {
                update(nextAmountCol, nextAmountUpdate, 2)
                console.log("Updating nextAmountUpdate:", nextAmountUpdate)
            }
        } //// / brackets repair
        if (reader[rfs][7].substring(0, 2) === "A2") { currentTable.rows[i].cells[amountCol].innerText = "Closed"; }
        }}}}   
    updateTable();          
}

async function clientPaperwork(idNumber) {
    console.log("clientPaperwork", idNumber);
    console.log("clientItems:", clientItems);
    const action = "getContract";
    dataSetA[2][5] = "true";
    dataSetA[0][1] = action;
    dataSetA[1][1] = "POST";
    dataSetA[2][12] = "true";
    localStorage.setItem("dataSetA", JSON.stringify(dataSetA));
    const formData = new FormData();
    formData.append("action", "getContract"); // endpoints
    formData.append("Timestamp", idNumber);
    formData.append("dataSetA", JSON.stringify(dataSetA));
    const response = await fetch("https://jplbuilders-contracting.com/API/uploadImages", {
        method: "POST",
        body: formData
    });
    const result = await response.json();
    if (!result.ok) {
    console.error("Failed to retrieve contract JSON:", result.error);
    return;
    }
    const finalJson = result.json;
    const snapshot = finalJson.snapshot;
    console.log("snapshot", snapshot)
    const contractHistory = finalJson.contractHistory;
    console.log("contractHistory", contractHistory)
    const mergedSnapshot = applyContractHistoryToClone(snapshot, contractHistory);
    console.log("mergedSnapshot", mergedSnapshot)
    const contractWrapper = document.getElementById("contractContent");
    if (!contractWrapper) {
        console.error("contractWrapper not found on page");
        return;
    }
    contractWrapper.innerHTML = "";
    reconstructContract(mergedSnapshot, contractWrapper);
    const certificateClone = await cloneCertificateForExport();
    const contractClone = await cloneContractForExport();
    if (!certificateClone || !contractClone) {
    console.error("Cloning failed");
    return;
    }
    // const staticHtml = buildCombinedHtml(certificateClone, contractClone);
    console.log("idNumber", idNumber)
    const staticHtml = buildCombinedHtml(certificateClone, contractClone, idNumber);
    const logoBuffer = await fetchImageAsArrayBuffer("/Images/company_logo.png");
    const sealBuffer = await fetchImageAsArrayBuffer("/Images/seal_b.png");
    const sealBuffer2 = await fetchImageAsArrayBuffer("/Images/contractualSeal_e.jpg");
    const accreditedStatus = snapshot.inputs["accredited_status"] || "";
    await exportCertificateAndContractDocx({
        certificateClone,
        maturityRecord: placeDataInv[recordNumber],
        idNumber,
        logoBuffer,
        sealBuffer,
        sealBuffer2,
        //accreditedStatus: accredited,
        //accreditedStatus,
        snapshot,
        //templateText: contractTemplates["2.4"].vector
    });
    
    
 
    /*
// Open a real browser tab (not a blob, not a download)
const printWindow = window.open("", "_blank");

// Write the HTML directly into the new tab
printWindow.document.open();
printWindow.document.write(staticHtml);
printWindow.document.close();

// Optional: automatically open the print dialog
// (This uses the HTML print engine, not the PDF viewer)
printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
};
   */
  /* 
    const blob = new Blob([staticHtml], { type: "text/html" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `JP Levesque Builders_${idNumber}.html`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  */  
}

function cancelUpdate1() {
    window.location.href = "clientEarnings.html";
    var checkboxes = document.querySelectorAll("input[type=checkbox]");
    for (var i = 0; i < checkboxes.length; i++) {
    checkboxes[i].checked = false;
    document.getElementById("newInvestAmount").value = "";
    }
    };
function validateReinvestmentAmount(value) {
    const regex = /^[0-9.\-,]*$/;
    const errorMessageElement = document.getElementById("newInvestAmountValidationError");
    let sanitized = value
        .normalize('NFKC')
        .trim()
        .replace(/[\s\u200B-\u200D\uFEFF]/g, '') // invisible whitespace
        .replace(/\p{C}/gu, '')                 // control characters
        .replace(/\p{M}/gu, '');                // combining marks
    // field is empty
    if (!sanitized) {
        errorMessageElement.innerText = "";
        s9 = 0;
        return;
    }
    if (!regex.test(sanitized)) {
        errorMessageElement.innerText = "Only numbers are allowed.";
        console.log("Invalid Character Detected ? s9 = 1");
        s9 = 1;
    } else {
        errorMessageElement.innerText = "";
        s9 = 0;
    }
}
function returnOnInvestment(Amount, Rate, Term, paymentOption, index) {
    console.log("***************************CALCULATING INTEREST FOR", valuesSpec, "*****************")
    console.log("reinvestmentAmount", reinvestmentAmount, typeof reinvestmentAmount)
    console.log("itemUpdate[2]", itemUpdate[2], typeof itemUpdate[2])
    console.log('ContractTerms[version]["B"][index].lLimit', ContractTerms[version]["B"][index].lLimit, typeof ContractTerms[version]["B"][index].lLimit)
    if (rfs2 === 0 && r === 0) {
        r = 1;
        rfs2 = 1;
    }
    const originationDate = reader[r - 1][5]; 
    // const originationDate = reader[defaultItem - 2][5]; ////// 
    console.log("r2", r)
    let Origin;
    if (originationDate !== "Pending Origination") { ///////////////
    Origin = originationDate.replace(/\(Indefinite\)/gi, "").trim();
    } else {
    Origin = new Date();
    }
    var interestValue = interestCalc1(Origin, Amount, Rate, Term);
    itemUpdate[6] = getString(interestValue); // ROI
    itemUpdate[8] = getString(getNumber(Amount) + getNumber(itemUpdate[6]));
    console.log("itemUpdate[6]", itemUpdate[6])
    console.log("itemUpdate[8]", itemUpdate[8])
    console.log("par", par)
    if (paymentOption === 1) {
    adjustedUpdateAmount = reinvestmentAmount;
    console.log("At paymentOption 1")
    if (paymentOptions === 1) {
    console.log("itemUpdate[8])", itemUpdate[8], typeof itemUpdate[8])
    itemUpdate[9] = getString(getNumber(itemUpdate[8]) - adjustedUpdateAmount); 
    } else if (paymentOptions === 2) {
    adjustedUpdateAmount = getNumber(Amount); /////
    itemUpdate[9] = getString(getNumber(itemUpdate[8]) - adjustedUpdateAmount); /////
    } else {
    itemUpdate[9] = getString(getNumber(itemUpdate[8]) - adjustedUpdateAmount);
    }
    }
    if (paymentOption === 2) {}
    if (paymentOption === 3) {
    console.log("At paymentOption 3")
    payment = getNumber("$0.00");
    if (paymentOptions === 1) {
    itemUpdate[9] = getString(getNumber(itemUpdate[8]) - reinvestmentAmount);
    adjustedUpdateAmount = reinvestmentAmount;
    } else if (paymentOptions === 2) {
    itemUpdate[9] = getString(payment);
    adjustedUpdateAmount = getNumber(itemUpdate[8]) - payment; /////
    //getNumber(Amount); /////

    } else {
    itemUpdate[9] = getString(payment);
    adjustedUpdateAmount = getNumber(itemUpdate[8])
    }
    }
    if (paymentOption === 4) {
    console.log("At paymentOption 4")
    if (paymentOptions === 1) {
    itemUpdate[9] = getString(getNumber(itemUpdate[8]) - reinvestmentAmount);
    adjustedUpdateAmount = reinvestmentAmount;
    } else if (paymentOptions === 2) {
    payment = getNumber(itemUpdate[6]);
    itemUpdate[9] = getString(payment);
    adjustedUpdateAmount = getNumber(Amount);   
    } else {
    payment = getNumber(itemUpdate[6]);
    itemUpdate[9] = getString(payment);
    adjustedUpdateAmount = getNumber(itemUpdate[8]) - payment;
    }
    }    
}
   
function editTerms(checkbox) {
    console.log("IN EDIT_TERMS");
    var sectionAElements = Array.from(document.getElementsByClassName("section1"));
    var sectionAChecked = sectionAElements.some(checkbox => checkbox.checked);
    var sectionBChecked = Array.from(document.getElementsByClassName("section2")).some(checkbox => checkbox.checked);
    if (sectionAChecked && sectionBChecked) {
        // Both sections have at least one checked box
    } else {
        if (sectionAElements[1] && sectionAElements[1].checked) {
            // Second checkbox in section A is checked
        } else {
            console.log("returning at null")
            return;
        }
    }    
    if ((!itemUpdate[2]) || itemUpdate[2] === 0) {
    alert("Bad Value");
    }
    console.log("itemUpdate[2]:", itemUpdate[2], typeof itemUpdate[2])
    console.log("ITEM UPDATE:", itemUpdate)
    console.log("r:", r);
    if (record[1] !== "Pending") {var activeNote = true};
    if (record[1] === "Pending") {var activeNote = false};
    errorMessageElement2 = errorMessageElement;
    //paymentAdjustment = 0; ////
    reinvestmentAmountAdjustment = null; //////
    if (!par) {
        par = getNumber(itemUpdate[2]);
        //alert("par:", par);
    }
    if (par !== getNumber(itemUpdate[2])) {
        par = getNumber(itemUpdate[2]);
    }
    //console.log("par is:", par, typeof par)
    if (checkbox && checkbox.id) {
    errorMessageElement = document.getElementById(checkbox.id + "Error");
    } else {
    errorMessageElement = null;
    }
    let submitButton = document.getElementById("submitButton");
    if (s1 === 0) {
    submitButton.disabled = false;
    };
    if (errorMessageElement2 !== null) {
    errorMessageElement2.innerHTML = "";
    }
    if (errorMessageElement !== null) {
    errorMessageElement.innerHTML = "";
    }
    index = null;
    //adjustedUpdateAmount = null;
    //adjustedUpdateAmount = null; //////
    //adjustedUpdateAmount = par;
    paymentOption = 0;
    paymentOptions = 0; 
    payment = 0;
    let maturity = 0; 
    var newAmount = 0;
    const reinvestmentAmount1 = document.getElementById("newInvestAmount").value;
    //if (!reinvestmentAmount1)
    if (reinvestmentAmount1) {
    reinvestmentAmount = getNumber(reinvestmentAmount1);
    } else {
        reinvestmentAmount = null;
    }
    let errorsMessageElement = document.getElementById("newInvestAmountValidationError").innerText;
    if (errorsMessageElement) {
        return;
    }
    let value1 = reinvestmentAmount1;
    if (value1 !== "") {
        validateReinvestmentAmount(value1);
        if (s9 === 1) { 
        return;
        }
    }
function checkboxSection1() {
    //console.log("CHECKBOX SECTION 1")
    var checkboxes = document.querySelectorAll(".section1");
    checkboxes.forEach(function(checkbox) {
    if (checkbox.checked) {
    switch (checkbox.id) {
    case "option1":
    console.log("in option1")
    if (checkbox.id === "option1" && checkbox.checked === true) { // racing?
    if (reinvestmentAmount) {
    if (reinvestmentAmount < 0) {
    console.log("in option1A")
    submitButton.disabled = true; s1 = 1;
    return; ////  
    } else if (reinvestmentAmount >= 0) {
    console.log("REINVESTMENT AMOUNT_1:", reinvestmentAmount, typeof reinvestmentAmount)
    paymentOption = 1;
    submitButton.disabled = false; s1 = 0;
    console.log("in option1B");
    }
    } else {
    return; 
    }
    }
    break;
    case "option2":
    console.log("in option2")
    paymentOption = 2;
    console.log("reader[r - 1][9]", reader[r - 1][9])
        itemUpdate[9] = itemUpdate[2];
    /*
    if (getNumber(reader[r - 1][9]) < 0) {
    if (reader[r - 1][7].substring(0, 2) === "A1") {
    itemUpdate[9] = reader[r - 1][8];
    } 
    } else if (getNumber(reader[r - 1][9]) > 0) {
    if (reader[r - 1][7].substring(0, 2) === "A1") {
    itemUpdate[9] = reader[r - 1][8];
    }
    }
    */
    //var rolloverStatus = "Closed";
    var sectionBChecked = Array.from(document.getElementsByClassName("section2")).some(checkbox => checkbox.checked);
    if (sectionBChecked === true) { 
    Array.from(document.getElementsByClassName("section2")).forEach(checkbox => checkbox.checked = false);
    }
    break;
    case "option3":
    console.log("in option3")
    paymentOption = 3;  
    break;
    case "option4":
    console.log("in option4")
    paymentOption = 4;
    break;
    }
    }
    })
    checkboxSection2()
    }
function termValidation(errorMessageElement, ContractTerms, activeNote, index, interestApr, productTerm) {
    let errorMessage = []; let errorMessages = ""; s1 = 0; let payment2 = ""; let payment3 = "";
    errorMessage[0] = "", errorMessage[1] = "", errorMessage[2] = ""; errorMessage[3] = "";
    console.log("Getting Update Values")
    let Amount = String(par); let Rate = interestApr; let Term = productTerm
    itemUpdate[3] = String(Rate);
    itemUpdate[4] = String(Term);
    valuesSpec = "Original Input";
    returnOnInvestment(Amount, Rate, Term, paymentOption, index)
    console.log("REINVESTMENT AMOUNT_2:", reinvestmentAmount, typeof reinvestmentAmount)
    console.log("COUNTER", x1++)
    console.log("------------reinvestmentAmount", reinvestmentAmount)
    console.log("par", par)
    console.log("ContractTerms[version]['B'][index].lLimit", ContractTerms[version]["B"][index].lLimit)
    console.log("paymentOption", paymentOption)
if (par < ContractTerms[version]["B"][index].lLimit && paymentOption !== 2) {
    console.log("****************************CALCULATING LOWER LIMIT VALUES**********************************")
    console.log("par", par)
    console.log("itemUpdate[2]", itemUpdate[2])
    payment2 = getString(ContractTerms[version]["B"][index].lLimit - par);
    //payment2 = getString(ContractTerms[version]["B"][index].lLimit - getNumber(reader[r - 1][8])); //// /
    payment3 = getString(Math.abs(getNumber(payment2)));
    // payment3 = getString(getNumber(payment2) * (-1)); //// /
    errorMessage[2] = "<p>" + "Alert: The reinvestment amount is less than the lower limit for the note selected." + "<p>" + "This investment selection requires an additional payment of " + payment2 + " before maturity to reinvest.";
    paymentOptions = 2;
    const adjustedPar = ContractTerms[version]["B"][index].lLimit;
    paymentAdjustment = getNumber(reader[r - 1][8]) - adjustedPar;
    reinvestmentAmountAdjustment = adjustedPar;
    Amount = String(adjustedPar);
    valuesSpec = "Under Limit Input";
    console.log("Amount:", Amount, typeof Amount)
    console.log("reader[r - 1][8]:", reader[r - 1][8], typeof reader[r - 1][8])
    console.log("reader[r - 1][9]:", reader[r - 1][9], typeof reader[r - 1][9])
    returnOnInvestment(Amount, Rate, Term, paymentOption, index);
    } else {
    // returnOnInvestment(Amount, Rate, Term, paymentOption, index) /////
    }
    
//if (getNumber(itemUpdate[2]) > getNumber(itemUpdate[8])) {
    console.log("adjustedUpdateAmount", adjustedUpdateAmount, typeof adjustedUpdateAmount)
    /*    
if (!reinvestmentAmount && adjustedUpdateAmount > getNumber(itemUpdate[8] && paymentOption !== 2 && paymentOption !== 1)) {
    console.log("Section: adjustedUpdateAmount > mature value")
        payment2 = getString(getNumber(itemUpdate[2]) - getNumber(itemUpdate[8]));
        payment3 = getString(getNumber(payment2) * (-1));
        paymentOptions = 1;
        Amount = String(par);
        valuesSpec = "Value is Greater";
        console.log("debug value footprint")
        errorMessage[3] = "<p>" + "Alert: This selection requires an additional payment of " + payment2 + " before maturity to reinvest.";
        returnOnInvestment(Amount, Rate, Term, paymentOption, index);
        itemUpdate[9] = getString(getNumber(itemUpdate[8]) - adjustedUpdateAmount);
    } 
    */
    if (par < 0) {  
    submitButton.disabled = true;
    s1 = 1;
    }
    console.log('ContractTerms[version]["B"][index].uLimit', ContractTerms[version]["B"][index].uLimit, typeof ContractTerms[version]["B"][index].uLimit)
    if (getNumber(Amount) > ContractTerms[version]["B"][index].uLimit && ContractTerms[version]["B"][index].uLimit !== 0) {
    //errorMessage[3] = "<p>" + "Error: The reinvestment amount is greater than the upper limit for the note selected.";
    //submitButton.disabled = true;
    //s1 = 1;
    }
    console.log("interestApr:", interestApr, typeof interestApr)
    console.log("reader[r - 1][3]", reader[r - 1][3], typeof reader[r - 1][3]) // // 
    console.log("r:", r, typeof r)
    console.log("currentTable.rows", currentTable.rows, typeof currentTable.rows)
    if (interestApr < getNumber(reader[r - 1][3])) {
    errorMessage[2] = "<p>" + "Alert: The interest rate of this product is lower.";
    submitButton.disabled = false;
    };
    for(let i = 0; i < errorMessage.length; i++) {
    if (errorMessage[i] !== "" && errorMessage[i] != null) {
    errorMessages = errorMessages + errorMessage[i] + "<br>";
    }
    }
    if (errorMessageElement?.id && errorMessages) {
        console.log("Entering Error Message", errorMessageElement.id)
    if (errorMessageElement.id != undefined && errorMessageElement.id !== "" && errorMessageElement.id !== "newInvestAmountError") { 
    //errorMessageElement.innerHTML = "<div id='editError'><fieldset>" + errorMessages + "</fieldset></div>";
    console.log("Writing Error Message")
    errorMessageElement.innerHTML = "<div id='editError' class='editError'><fieldset>" + errorMessages + "</fieldset></div>";
    }
    }
    //color:#1788e4;
    /*
    itemUpdate[7] = getString(payment);
    if (payment !== getNumber(itemUpdate[9])) {
    let t = currentTable;
    let r = t.rows[1]; 
    let c = r.cells[9];
    if (getNumber(itemUpdate[9]) >= 0 || getNumber(itemUpdate[9]) < 0) {
    c.innerHTML = itemUpdate[9];
    } 
    itemUpdate[9] = itemUpdate[8];
    }
    */
   
    };
function checkboxSection2() {
    console.log("GETTING RATES")
    var checkboxes = document.querySelectorAll(".section2");
    checkboxes.forEach(function(checkbox) {   
    if (checkbox.checked) {
        console.log("version:", version, typeof version)
    switch (checkbox.id) {
        case "product1":
        index = 0; 
        interestApr = ContractTerms[version]["B"][index].APR;
        productTerm = ContractTerms[version]["B"][index].term;
        termValidation(errorMessageElement, ContractTerms, activeNote, index, interestApr, productTerm)
        break;
        case "product2":
        index = 1;
        interestApr = ContractTerms[version]["B"][index].APR;
        productTerm = ContractTerms[version]["B"][index].term;
        termValidation(errorMessageElement, ContractTerms, activeNote, index, interestApr, productTerm)
        break;
        case "product3":
        index = 2;
        interestApr = ContractTerms[version]["B"][index].APR;
        productTerm = ContractTerms[version]["B"][index].term;
        termValidation(errorMessageElement, ContractTerms, activeNote, index, interestApr, productTerm)
        break;
        case "product4":
        index = 3;
        interestApr = ContractTerms[version]["B"][index].APR;
        productTerm = ContractTerms[version]["B"][index].term;
        termValidation(errorMessageElement, ContractTerms, activeNote, index, interestApr, productTerm)
        break;
        case "product5":
        index = 4;
        interestApr = ContractTerms[version]["B"][index].APR;
        productTerm = ContractTerms[version]["B"][index].term;
        termValidation(errorMessageElement, ContractTerms, activeNote, index, interestApr, productTerm)
        break;
        case "product6":
        index = 5;
        interestApr = ContractTerms[version]["B"][index].APR;
        productTerm = ContractTerms[version]["B"][index].term;
        termValidation(errorMessageElement, ContractTerms, activeNote, index, interestApr, productTerm)
        break;
        case "product7":
        index = 6;
        interestApr = ContractTerms[version]["B"][index].APR;
        productTerm = ContractTerms[version]["B"][index].term;
        termValidation(errorMessageElement, ContractTerms, activeNote, index, interestApr, productTerm)
        break;
        case "product8":
        index = 7;
        interestApr = ContractTerms[version]["B"][index].APR;
        productTerm = ContractTerms[version]["B"][index].term;
        termValidation(errorMessageElement, ContractTerms, activeNote, index, interestApr, productTerm)
        break;
        case "product9":
        index = 8;
        interestApr = ContractTerms[version]["B"][index].APR;
        productTerm = ContractTerms[version]["B"][index].term;
        termValidation(errorMessageElement, ContractTerms, activeNote, index, interestApr, productTerm)
        break;
        };
        console.log("index:", index, typeof index)
    };
});
console.log("itemUpdate[2]", itemUpdate[2])
console.log("******* END OF FUNCTION *******")  
};
checkboxSection1();
reinvestmentAmount = 0; /////
paymentOptions = 0;
paymentOption = 0;
console.log("adjustedUpdateAmount", adjustedUpdateAmount, typeof adjustedUpdateAmount)
};
function updateTable() {
    let amount = [], contractTerms = [], roi = [], matureValue = [], payment = [], nextAmount = [];
    let isContinuous = [];
    const column = 1;
    for (let i = 1; i < currentTable.rows.length; i++) {
    const isFirst = i === 1;
    const amountCol = isFirst ? 2 : 1;
    const roiCol = isFirst ? 6 : 5;
    const contractCol = isFirst ? 7 : 6;
    const matureCol = isFirst ? 8 : 7;
    const payoutCol = isFirst ? 9 : 8;
    const nextAmountCol = (i === 1) ? 1 : column;   
    amount[i] = getNumber(currentTable.rows[i].cells[amountCol].innerText);
    roi = getNumber(currentTable.rows[i].cells[roiCol].innerText);
    contractTerms[i] = currentTable.rows[i].cells[contractCol].innerText;
    if (!contractTerms[i]) { isContinuous[i] = false; } else { isContinuous[i] = true; }
    matureValue[i] = getNumber(currentTable.rows[i].cells[matureCol].innerText);
    payment[i] = getNumber(currentTable.rows[i].cells[payoutCol].innerText);
    if (currentTable.rows[i + 1]) {
        if (currentTable.rows[i + 1].cells[nextAmountCol].innerText !== "Closed") {
            nextAmount[i] = getNumber(currentTable.rows[i + 1].cells[nextAmountCol].innerText);
        } else {
            nextAmount[i] = getNumber(reader[i][2]);
          };
            if (contractTerms[i]?.substring(0, 2) !== "A1") {
                if (contractTerms[i]?.substring(0, 2) === "A2") {
       
                }
                if (contractTerms[i]?.substring(0, 2) === "A3") {
                    if (matureValue[i] !== nextAmount[i]) {
                        if (currentTable.rows[i + 1].cells[nextAmountCol].innerText === "Closed") {
                        currentTable.rows[i + 1].cells[payoutCol].innerText = getString(matureValue[i] - 0); 
                        reader[i - 1][9] = getString(0);
                        }
                        if (currentTable.rows[i + 1].cells[nextAmountCol].innerText !== "Closed") {
                            currentTable.rows[i].cells[payoutCol].innerText = getString(matureValue[i] - nextAmount[i]);
                            reader[i - 1][9] = getString(matureValue[i] - nextAmount[i]);
                        }
                    }   
                }
                if (contractTerms[i]?.substring(0, 2) === "A4") {
                    // console.log("payoutCol", payoutCol)
                    // console.log("nextAmount[i]", nextAmount[i])
                    // console.log("reader[i - 1][9]", reader[i - 1][9])
                    if (matureValue[i] - roi[i] !== nextAmount[i]) {
                        currentTable.rows[i].cells[payoutCol].innerText = getString(matureValue[i] - nextAmount[i]); 
                        reader[i - 1][9] = getString(matureValue[i] - nextAmount[i]);
                        // console.log("currentTable.rows[i].cells[payoutCol].innerText", currentTable.rows[i].cells[payoutCol].innerText)
                    }
                }
            } else {} // done
    } else if (currentTable.rows[i + 1]?.cells[nextAmountCol].innerText === "Closed") {} //// done
}
}

function reinvestmentAmountAdjustments() {
    //if (itemUpdate[7].substring(0, 2) === "A1" && r > 0) { //////
    if (itemUpdate[7].substring(0, 2) === "A1") {
    currentTable.rows[r + 2].cells[1].innerText = reader[r + 1][2];
    }
    let t = currentTable;
    let rewriteLoc;
    let rowLoc = t.rows[r + 1];
    if (r === 0) {
    rewriteLoc = rowLoc.cells[2];   
    } else {
    rewriteLoc = rowLoc.cells[1];
    }
    rewriteLoc.innerHTML = getString(reinvestmentAmountAdjustment);
    //rewriteLoc.style.color = "rgb(26, 141, 234)";
    //cellH.style.cssText = redStyle;
    rewriteLoc.style.color = "red";
    reader[r][2] = getString(reinvestmentAmountAdjustment)
    reinvestmentAmountAdjustment = null;       
    }

function paymentAdjustments() {
    let t = currentTable;
    let rewriteLoc;
    let rowLoc = t.rows[r];
    if (r === 1) {
    rewriteLoc = rowLoc.cells[9];   
    } else {
    rewriteLoc = rowLoc.cells[8];
    }
    rewriteLoc.innerHTML = getString(paymentAdjustment);
    rewriteLoc.style.color = "red";
    reader[r - 1][9] = getString(paymentAdjustment)
    paymentAdjustment = null;
    }

function submitFormA() {
    let date = new Date();
    let timestamp = date.toISOString();

    let username = document.getElementById("username").value;
    let password = document.getElementById("password").value;
    let note = document.getElementById("note").value;

    let data = {
        Username: username,
        Password: password,
        Timestamp: timestamp,
        Note: note
    };
    // Creating a form dynamically (as an alternative to fetch or http methods)
    let form = document.createElement("form");
    form.method = "post";
    form.action = "/submit";
    for (let key in data) {
        if (data.hasOwnProperty(key)) {
            let hiddenField = document.createElement("input");
            hiddenField.type = "hidden";
            hiddenField.name = key;
            hiddenField.value = data[key];
            form.appendChild(hiddenField);
        }
    }
    document.body.appendChild(form);
    form.submit();
}
           
// needs to check for valid update. i.e. edit data exists.
function editNote() {
    //if (reader[reader.length - 1][2] != "Closed") {
    //reader[reader.length - 1] = [];
    //}
    let change = [[]]; 
    change = reader;
    dataSetA = JSON.parse(localStorage.getItem('dataSetA'));
    //console.log("dataSetA", dataSetA);
    console.log("change before server", change)
    let date = record[0]; 
    //console.log("date", date, typeof date)
    //let index = 0; //// /////
    if (record[0]) {   
        if (typeof record[0] === 'string' && record[0].includes(" (Example)")) {
            console.log("Example Notes Cannot be Updated to the Database:");
            return;
        }
    }
let parsedTime;
let timestamp;
if (typeof date === 'string') {
parsedTime = parseInt(date, 10); 
}
    if (isNaN(parsedTime)) {
        console.error("Invalid timestamp after parsing:", parsedTime);
        return "error";
    }
    try {
    timestamp = new Date(parsedTime);
    if (isNaN(timestamp.getTime())) {
        console.log("Invalid date format:", date);
        return;
    } else {
        console.log("TIMESTAMP_A:", timestamp, typeof timestamp)
        timestamp = record[0];
        console.log("TIMESTAMP_B:", timestamp, typeof timestamp)
    }
console.log("TIMESTAMP_C:", timestamp);
} catch (error) {
    console.log("Error processing date:", date);
    return;
};
const action = "editNote";
dataSetA[2][5] = "true";
dataSetA[0][1] = action;
dataSetA[1][1] = 'PATCH';
dataSetA[2][12] = "true";
dataSetA[7][2] = "";
dataSetA[7][2] = change;
let files = [];
(async function () {
    const endpoint = "https://jplbuilders-contracting.com/API/editNote";
    const items = {
        Timestamp: record[0]
    };
    const requestOptions = {
        method: dataSetA[1][1],
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "https://jplbuilders-contracting.com",
            "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
            "Access-Control-Allow-Headers": "Content-Type, Access-Control-Allow-Methods"
        },
        body: JSON.stringify({ items, dataSetA })
    };
    try {
        const data = await DataInterface(requestOptions, endpoint);       
        if (!dataSetA[2][3]) {
            resultMessage = "";
        } else {
            dataSetA[7][2] = "";
            resultMessage = dataSetA[2][3];
        }
        dataSetA = JSON.parse(localStorage.getItem("dataSetA"));
        placeDataInv = JSON.parse(localStorage.getItem("placeDataInv"));
        //window.location.href = "clientEarnings.html";
        //window.location.replace("/clientEarnings.html"); 
        return;
    } catch (error) {
        console.error("Error during DataInterface call:", error);
    }
    console.log("old response block");
    if (!dataSetA[2][3]) {
        resultMessage = "";
    } else {
        dataSetA[7][2] = "";
        resultMessage = dataSetA[2][3];
    }
    dataSetA = JSON.parse(localStorage.getItem("dataSetA"));
    placeDataInv = JSON.parse(localStorage.getItem("placeDataInv"));
})();
}

function interestCalc1(Origin, Amount, Rate, Term) {
    let amount = getNumber(Amount);
    let termStart;
    //console.log("Typeof Origin", typeof Origin);
        if (typeof Origin === 'string') {
            // Remove any label artifacts "(Indefinite)"...
            Origin = Origin.replace(/\(.*?\)/g, '').trim();    
            const parsed = Date.parse(Origin);
            if (!isNaN(parsed)) {
                termStart = new Date(parsed);
            } else if (Origin.length === 13 && !isNaN(Number(Origin))) {
                termStart = new Date(Number(Origin));
            } else {
                console.warn("? Origin is not a valid Date or timestamp:", Origin);
                return null;
            } 
        } else if (Origin instanceof Date && !isNaN(Origin)) {
        termStart = new Date(Origin.getTime());
    } else {
        console.log("Origin is not a valid Date or timestamp.");
        return null;
    }
    //console.log("Typeof termStart", typeof termStart, termStart);
    let termMonths = parseInt(Term, 10);
    //console.log("TERMMONTHS", termMonths, typeof termMonths);
    let endDate = new Date(
        termStart.getFullYear(),
        termStart.getMonth() + termMonths,
        termStart.getDate()
    );
    let totalMilliseconds = endDate.getTime() - termStart.getTime();
    let totalDays = totalMilliseconds / (24 * 60 * 60 * 1000);
    totalDays = Math.round(totalDays);
    let rate = Rate / 100;
    let dailyRate = rate / 365;
    let interest = amount * Math.pow(1 + dailyRate, totalDays) - amount;
    return interest;
}

function interestCalc1A(Origin, Amount, Rate, Term){
    let amount = getNumber(Amount);
    let termStart;
    console.log("Typeof Origin", typeof Origin)
    if (typeof Origin === 'string' && Origin.length === 13 && !isNaN(Number(Origin))) {
        termStart = new Date(Number(Origin));
    }
    else if (!(Origin instanceof Date) || isNaN(Origin)) {
        console.log("Origin is not a valid Date object.");
    } else {
        termStart = new Date(Origin);
    }
    console.log("Typeof termStart", typeof termStart, termStart)
    let termMonths = parseInt(Term, 10);
    console.log("TERMMONTHS", termMonths, typeof termMonths)
    let endDate = new Date(termStart.getFullYear(), termStart.getMonth() + termMonths, termStart.getDate()); 
    let totalMilliseconds = endDate.getTime() - termStart.getTime();
    let totalDays = totalMilliseconds / (24 * 60 * 60 * 1000);
    totalDays = Math.round(totalDays);
    let rate = Rate / 100; 
    let dailyRate = rate / 365;
    let number3 = amount * Math.pow(1 + dailyRate, totalDays);
    number3 = number3 - amount;
    return number3;
}

function getMaturity(Origin, Term) {
    console.log("ORIGIN", Origin);
    let termStart = new Date(Origin);
    console.log("termStart", termStart);   
    let termMonths = parseInt(Term, 10);
    let endDate = new Date(termStart.getFullYear(), termStart.getMonth() + termMonths, termStart.getDate());
    let maturityTimestamp = endDate.getTime(); // timestamp in milliseconds
    return maturityTimestamp;
}
function indefinite(monthsAhead, originDate, term) {
    term = parseInt(term, 10);
    monthsAhead = monthsAhead.map(m => parseInt(m, 10));
    const rawDate = originDate[0];
    if (rawDate !== "Pending Origination" && /^\d{13}$/.test(rawDate) || rawDate !== "Pending" && /^\d{13}$/.test(rawDate) ) {
        console.log("Indedfinite A_1")
        const dateObj = new Date(parseInt(rawDate, 10));
        const formattedDateString = dateObj.toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric"
        });
        //currentTable[1][5].textContent = formattedDateString; // verify attribute is not updated
        originDate[0] = formattedDateString;
    } else {
        console.log("Indefinite A_2")
    originDate[0] = reader[0][0];
    const dateObj = new Date(parseInt(originDate[0], 10));
    const formattedDateString = dateObj.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric"
    });
    //currentTable[1][5].textContent = formattedDateString; // verify
    originDate[0] = formattedDateString;
    }
    console.log("ItemUpdate[5] origin date:", originDate[0], typeof originDate[0])
    const parseDate = (date) => {
        if (typeof date === "string") {
            const trimmed = date.replace(/\(Indefinite\)/gi, "").trim();
            const parsed = Date.parse(trimmed);
            if (!isNaN(parsed)) return new Date(parsed);
        }
        if (!isNaN(date)) return new Date(parseInt(date, 10));
        return;
    };
    const validDates = originDate.map(parseDate);
    console.log("Valid Dates", validDates)
    const maturityChain = [];
    for (let i = 0; i < originDate.length; i++) {
        let baseDate;
        if (i === 0) {
            baseDate = validDates[0];
            if (baseDate === "Pending Origination" || baseDate ==="Pending") {
                console.log("block 3, get new time")
                console.log("block 3, value i:",i)
                console.log("baseDate_1", baseDate, typeof baseDate)
                const fallback = new Date();
                baseDate = new Date(fallback.getTime());
                console.log("baseDate", baseDate)
            } else if (!(baseDate instanceof Date) || isNaN(baseDate.getTime())) {
                const fallback = new Date();
                baseDate = new Date(fallback.getTime());  
            }
            console.log("Normalized Date", baseDate)
        } else {
            console.log("else base date from maturity chain, value i:",i)
            baseDate = maturityChain[i - 1];
            console.log("baseDate", baseDate)
        }
        const rowTerm = monthsAhead[i] || 0;
        const maturityDate = new Date(baseDate.getTime());
        maturityDate.setMonth(maturityDate.getMonth() + rowTerm);
        console.log("set maturityDate", maturityDate)
        maturityChain.push(maturityDate);
    }
    const finalBase = maturityChain[maturityChain.length - 1];
    const finalDate = new Date(finalBase.getTime());
    console.log("finalBase", finalBase)
    ////finalDate.setMonth(finalDate.getMonth() + term); ////
    finalDate.setMonth(finalDate.getMonth());
    console.log("set finalDate", finalDate)
    return finalDate;
}
function interestCalc2(Origin, Amount, Rate, Term){
    let amount = getNumber(Amount);
    if (Rate.typeof = "string") {
        Rate = Number(Rate);
    }
    let termStart = new Date(Origin);
    let endDate = new Date(termStart.getFullYear(), termStart.getMonth() + Term, termStart.getDate()); 
    let totalMilliseconds = endDate.getTime() - termStart.getTime();
    let totalDays = totalMilliseconds / (24 * 60 * 60 * 1000);
    totalDays = Math.round(totalDays);
    let rate = Rate / 100; 
    let dailyRate = rate / 365;
    let number3 = amount * Math.pow(1 + dailyRate, totalDays);
    number3 = number3 - amount;
    //return endDate.getTime;
    return endDate;
}
function interestCalc3(Origin, Amount, Rate, productTerm){
    let amount = getNumber(Amount);
    let termStart = new Date(Origin);
    let endDate = new Date(termStart.getFullYear(), termStart.getMonth() + productTerm, termStart.getDate());
    let totalMilliseconds = endDate - termStart;
    let totalDays = totalMilliseconds 
    totalDays = Math.floor(totalDays);
    let rate = Rate / 100;
    let dailyRate = rate / 365; 
    let number3 = amount * Math.pow(1 + dailyRate, totalDays);
    number3 = number3 - amount;
    return number3;
};
function interestCalc4(Origin, Amount, Rate, Term){
    let amount = getNumber(Amount);
    let termStart = new Date(Origin);
    let endDate = new Date(termStart.getFullYear(), termStart.getMonth() + Term, termStart.getDate()); 
    let totalMilliseconds = endDate.getTime() - termStart.getTime();
    let totalDays = totalMilliseconds / (24 * 60 * 60 * 1000);
    totalDays = Math.round(totalDays);
    let rate = Rate / 100; 
    let dailyRate = rate / 365;
    let number3 = amount * Math.pow(1 + dailyRate, totalDays);
    number3 = number3 - amount;
    return number3;
};

async function getTable() {
    const action = "getTable";
    dataSetA[0][1] = action;
    dataSetA[1][1] = "GET";
    dataSetA[2][5] = 'true';
    dataSetA[7][1] = {};
    if (dataSetA[2][12] = "true") {
    localStorage.setItem("dataSetA", JSON.stringify(dataSetA))
    };
    const endpoint = "https://jplbuilders-contracting.com/API/getTable";
    //let items = {
    //};
    const requestOptions = {
        method: dataSetA[1][1],
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "https://jplbuilders-contracting.com",
            "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
            "Access-Control-Allow-Headers": "Content-Type, Access-Control-Allow-Methods"
        },
        body: JSON.stringify({ items: {}, dataSetA })
    };
    try {
        const result = await DataInterface(requestOptions, endpoint);
        console.log("Raw result:", result);

        const placeDataInv1 = placeDataInv;
        return Array.isArray(placeDataInv1) ? [...placeDataInv1] : [];

    } catch (error) {
        console.error("Error during DataInterface call:", error);

        // ?? Fallback to localStorage
        const placeDataInv1 = JSON.parse(localStorage.getItem("placeDataInv"));
        return Array.isArray(placeDataInv1) ? [...placeDataInv1] : [];
    }
}

function createRecords(x) {
    //console.log("createRecords())
    cell = document.createElement("td");
    cell.width = "auto";
    cell.align = "center";
    cell.style.fontWeight = "normal";
    if (x === 5) {
        cell.style.color = "rgb(0, 0, 0)";
    }
    if (x === 5 && reader[0][1] === "Pending") {
        cell.style.color = "rgb(26, 141, 234)";
    }
    if (x === 5 && reader[r][1] === "Pending") {
        cell.style.color = "rgb(26, 141, 234)";
    }
    return cell; 
}
function createRecord1(data, currentTable, functionOverload){
    //console.log("createRecord1()")
    cell = document.createElement("td");
    cell.dataset.extraValue = JSON.stringify({ itemNumber: itemNumber, fieldNumber: fieldNumber });
    cell.width = "auto";
    cell.align = "center";
    if (fieldNumber === 1 && data === "Pending") {
        cell.style.color = "rgb(26, 141, 234)";
    }
    if (fieldNumber === 5 && (data === "Pending" || data === "Indefinite")) {
        cell.style.color = "rgb(26, 141, 234)";
    }
    if (currentTable === functionOverload) {
            cell.id = `noteData[${fieldNumber}]`;type="text"
    } else {
        cell.id = `noteData[${itemNumber}][${fieldNumber}]`;
    }
    return cell;
};
function createRecord(itemNumber, fieldNumber, currentTable, functionOverload){
    //console.log("createRecord()")
    cell = document.createElement("td");
    cell.dataset.extraValue = JSON.stringify({ itemNumber: itemNumber, fieldNumber: fieldNumber });
    cell.width = "auto";
    cell.align = "center";
    if (fieldNumber === 1 && clientItems[itemNumber][fieldNumber] === "Pending") {
        console.log("Setting Color")
        cell.style.color = "rgb(26, 141, 234)";
    }
    if (fieldNumber === 5 && (clientItems[itemNumber][1] === "Pending" || clientItems[itemNumber][1] === "Indefinite")) {
        console.log("Setting Color1")
        cell.style.color = "rgb(26, 141, 234)";
    }
    if (currentTable === functionOverload) {
            cell.id = `noteData[${fieldNumber}]`;type="text"
    } else {
        cell.id = `noteData[${itemNumber}][${fieldNumber}]`;
    }
    if (fieldNumber === 10 && !dualMode) {
        const btn = document.createElement("input");
        btn.type = "button";
        btn.id = "updateNoteEdit";
        btn.value = button1; 
        cell.appendChild(btn);
    }
    return cell;
};
function dataEntry(formData,table){  //validateInput here and does n is overloaded and is dataEntry used anywhere ALSO, formData is a function elsewhere
    let object = {};
    formData.forEach(function(value, key){
        if (validateInput(value)) {// validateInput is used elsewhere without param
            let encryptedValue = encryptFunction(value);
            object[key] = encryptedValue;
        } else {
            console.error(`Invalid input: ${value}`);
        }
    });
    let json = JSON.stringify(object);
    fetch("/api", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: json
    });
};
function displayItem() {
    // Get the image element by its ID
    var imageElement = document.getElementById("image_s");
    // Set the new image source (modify this path as needed)
    imageElement.src = "/Images/_image_s.png";
    //imageElement.style.display = "none";
    };
         
function contractSeal(){
    // var contractForm = document.getElementById("contractForm");
    var image_s = document.getElementById("image_s");
    var div_m = document.getElementById("div_m");
    // contractForm.addEventListener("submit", function(e) {
        // e.preventDefault();
        // displayItem(); ////this function should be in backup contractA.html, for seal right click
        image_s.src = "/Images/contractualSeal_g.jpg";
        image_s.style.display = "block";
        div_m.style.display = "block";
        scroll2(); 
    // });
};
function contractSeal2() {
    var image_s = document.getElementById("image_s");
    var div_m = document.getElementById("div_m");
    // var sales = document.getElementById("closing")    
    image_s.src = "/Images/contractualSeal_g.jpg";
    image_s.style.display = "none";
    div_m.style.display = "none";
    // sales.style.display = "none";
    document.getElementById("divEnd1").style.display = "none";
    document.getElementById("divEnd2").style.display = "none";
}

function conflictDiv(complete) {
    if (complete === true) {
    document.getElementById("divEnd2").style.display = "none";
    // document.getElementById("divEnd2").innerHTML = "";
    document.getElementById("divEnd1").style.display = "none";
    // document.getElementById("divEnd1").innerHTML = "";
    } 
    if (complete === false) {
    document.getElementById("divEnd1").style.display = "none";
    // document.getElementById("divEnd1").innerHTML = "";
    document.getElementById("divEnd2").style.display = "none";
    // document.getElementById("divEnd2").innerHTML = "";
    }
}

function showDiv(complete) {  
    if (complete === true) {
    document.getElementById("divEnd1").style.display = "block";
    } 
    if (complete === false) {
    document.getElementById("divEnd2").style.display = "block";   
    }
    // complete = null;
};

function updateContactEmailError() {
    const errDiv = document.getElementById("contactEmailValidationError");

    // If validateInput has already set an error message, respect it
    if (errDiv.innerText && errDiv.innerText !== "Please verify the new contact email at that inbox.") {
        return; // leave whatever validateInput wrote
    }

    // If no error message is present and the flag is still false, show the inbox verification reminder
    if (!errDiv.innerText && dataSetA[2][9] === "false") {
        errDiv.innerText = "Please verify the new contact email at that inbox.";
    }

    // If the flag flips to true, clear the reminder
    if (dataSetA[2][9] === "true" && errDiv.innerText === "Please verify the new contact email at that inbox.") {
        errDiv.innerText = "";
    }
}

function validateInput() {
    let textareas = document.querySelectorAll("textarea");
    let inputFields = document.querySelectorAll("input");
    textareas.forEach(function(textarea) {
        textarea.addEventListener("input", function(event) {
            inputFunction(event)
        });
    });
    inputFields.forEach(function(inputField) {
        inputField.addEventListener("input", function(event) {
            inputFunction(event)
        });
    });
};
function inputFunction(event) {
    x++;   
    //console.log("EVENT", x, event.target, event.target.value, "s9 = ", s9)
    let value = event.target.value;
    //console.log([...value].map(c => c.charCodeAt(0)));
    value = value.normalize('NFKC');  
    let errorMessageElement = document.getElementById(event.target.id + "ValidationError");
    if (!errorMessageElement) {
    return;
    }

    // Allow empty input (avoid validation errors while typing or clearing)
    if (!value) {
        errorMessageElement.innerText = "";
        s9 = 0;
        return;
    }
    const regex = /^(?!.*[<>{};:&|\\/"'=])[\w.@,\- ]{1,100}$/;
    const cleaned = value
        .replace(/[\u200B-\u200D\uFEFF]/g, '')  // invisible whitespace
        .replace(/\p{C}/gu, '')                 // control characters
        .replace(/\p{M}/gu, '');                // combining diacritics
        //console.log("Cleaned value:", cleaned);

    if (!regex.test(cleaned)) {
        s9 = 1;
        errorMessageElement.innerText = "Only alphanumeric and special characters @ _ - . % or space are allowed.";
        //console.log("Invalid Character: s9 =", s9, "exit early");
    } else {
        s9 = 0;
        errorMessageElement.innerText = "";
        document.getElementById("submitError").innerText = "";
        let submitError2 = document.getElementById('submitError2');
        if (s93 === 0 && submitError2 && submitError2.innerText !== "") {
        submitError2.innerText = "";
        }
        let textareas = document.querySelectorAll("textarea");
        let inputFields = document.querySelectorAll("input");
        let allValid = true;
        if (textareas.length > 0) {  
            for (let textarea of textareas) {
                if (textarea.value) {
                if (!regex.test(textarea.value)) {  
                    allValid = false;
                }
            }
            }
        }
        if (inputFields.length > 0) {
            for (let inputField of inputFields) {
                if (inputField.value) {
                if (!regex.test(inputField.value)) {
                    allValid = false;  
                }
            }
            }
        }
        if (allValid) {    
            s9 = 0;
            //console.log("*** Exit at allValid_true *** setting s9 =", s9)
            document.getElementById("submitError").innerText = ""; 
        }
        if (!allValid) {
            s9 = 1;
        //console.log("*** Exit at allValid_false *** setting s9 =", s9)
        } 
    }
};
//*******************************/
function showMessage(resultMessage) {
    const message = document.getElementById('message');
    message.innerText = resultMessage;
    message.style.display = 'block';

    // Clear any previous timeout before setting a new one
    if (messageTimeout) {
        clearTimeout(messageTimeout);
    }

    messageTimeout = setTimeout(() => {
        message.style.display = 'none';
        message.innerText = "";
    }, 12000);
}
function processBackendResponse(response) {
    if (response === "success") {
      const inputs = document.querySelectorAll("input:not([readonly])");
      inputs.forEach(input => {
        if (["text","email","password"].includes(input.type)) {
        window.same.formFields[input.id] = input.value || "";
        }
      });
      window.same.change1 = {};
      window.same.v = false;
      //console.log("Baseline updated after backend response:", window.same.formFields);
    } else {
      console.error("Backend update failed:");
    }
  }
  
function truncateInput(sValue) {              
if (sValue) {
var truncated = sValue.substring(0, 0) + 'xxxxxxx' + sValue.substring(sValue.length - 2);
document.getElementById("tIN").value = truncated;
document.getElementById("ssn").value = "";    
sValue ="";
return truncated;
} 
}

function processChanges(event) { 
let button = document.activeElement;
changed = updateAccountChange();
//console.log("***changed***", changed)  
if (changed.hasOwnProperty('ssn') && changed.ssn !== "") {
changed.tIN = truncateInput(changed['ssn']);
}
if (button.id === "b3") {
for (let key in changed) {
if (key !== "routingNumber" && key !== "checkingAccount") {
delete changed[key];
}
}
}
if (button.id === "b4") {
for (let key in changed) {
if (key !== "ssn") {
delete changed[key];
}
}
changed.ssn = "";
changed.tIN = "";
window.same.v = false;
}
if (!window.same.v && !isEmptyObject(changed)) {
//console.log("Uploading");
let change = changed;
console.log("CHANGE", change)
changed = {};
//console.log("change at upload", change)
action = "editProfile";
dataSetA[0][1] = action;
dataSetA[1][1] = "PATCH";
dataSetA[7][1] = change;
resultMessage = "";
dataSetA[2][12] = "true";
localStorage.setItem("dataSetA", JSON.stringify(dataSetA));
dataSetA = JSON.parse(localStorage.getItem("dataSetA"));
(async function() {
const endpoint = "https://jplbuilders-contracting.com/API/editProfile";
let items = {
};
let requestOptions = {
method: dataSetA[1][1],
headers: {
"Content-Type": "application/json",
"Access-Control-Allow-Origin": "https://jplbuilders-contracting.com",
"Access-Control-Allow-Methods": "GET, POST, OPTIONS",
"Access-Control-Allow-Headers": "Content-Type, Access-Control-Allow-Methods",
},
body: JSON.stringify({ items, dataSetA })
};
try {
//await new Promise(resolve => setTimeout(resolve, 100));
await DataInterface(requestOptions, endpoint);
//dataSetA = JSON.parse(localStorage.getItem("dataSetA"));
//placeDataInv = JSON.parse(localStorage.getItem("placeDataInv"));
//clientInfo = JSON.parse(localStorage.getItem("clientInfo"));
//console.log("response::", dataSetA[2][4])
//console.log("message::", dataSetA[2][3])
//console.log("clientInfo.tIN::", clientInfo.tIN)
resultMessage = dataSetA[2][3];
showMessage(resultMessage);
if (clientInfo.tIN === "") {
document.getElementById('tIN').value = "";
}
processBackendResponse(dataSetA[2][8]);
dataSetA[7][1] = {};
if (!dataSetA[2][3]) {
resultMessage = "Unknown Database Error";
dataSetA[2][12] = "false";
} else {
dataSetA[2][12] = "false";
}
} catch (error) { 
console.error("Database Error:", error);
document.getElementById('message').innerText = "Unknown Database Error. Please try again or contact itAdmin@JPLBuilders-Contracting.com";
dataSetA[7][1] = {};
}
})();
}
}
function updateAccountChange() {
    let node = document.querySelectorAll("input:not([readonly])");
    let changes = {};
    //console.log("window.same.formFields2", window.same.formFields)
    let inputs = Array.from(node);
    //console.log("INPUTS", inputs)
    inputs.forEach(input => {
        if (input.type === "text" || input.type === "email" || input.type === "password") {
            let id = input.id;
            let value = input.value;
            //console.log("input ", input.id, ":", input.value)
            //console.log("window.same.formFields3", window.same.formFields)
            if (window.same.formFields[id] === value) {
                // No change
            } else if (value === null || value === "" || value === undefined || value === "undefined") {
                changes[id] = "";
            } else {
                changes[id] = value;
            }
        }
    });
    let change = Object.entries(changes).reduce((changed, [key, value]) => {
        changed[key] = value;
        return changed;
    }, {});
    if (change.hasOwnProperty("tIN")) {
        // delete change["tIN"];
        // delete change["ssn"];
        change.tIN = "";
        change.ssn = "";
    }
    if (JSON.stringify(window.same.change1) === JSON.stringify(change)) {
        window.same.v = true;
    } else {
        window.same.v = false;
    }
    inputs.forEach(input => {
        if (input.type === "text" || input.type === "email" || input.type === "password") {
            window.same.formFields[input.id] = input.value;
        }
    });
    window.same.change1 = change;
    return change;
}
function addEventListeners() {
    let textareas = document.querySelectorAll("textarea");
    let inputFields = document.querySelectorAll("input[type='text']");
    textareas.forEach(function(textarea) {
        textarea.addEventListener("input", inputFunction);
    });
    inputFields.forEach(function(inputField) {
        inputField.addEventListener("input", inputFunction);
    });
}
function removeEventListeners() {
    let textareas = document.querySelectorAll("textarea");
    let inputFields = document.querySelectorAll("input[type='text']");
    textareas.forEach(function(textarea) {
        textarea.removeEventListener("input", inputFunction);
    });
    inputFields.forEach(function(inputField) {
        inputField.removeEventListener("input", inputFunction);
    });
}
function verifyCompletion() {
    // let inputFields = document.querySelectorAll("input[type='text'], input[type='checkbox']");
    
    let inputFields = document.querySelectorAll("input[type='text']");
    completed = true; 
    inputFields.forEach(function(inputField) {
        if (inputField.type === 'text' && inputField.value.trim() === "") {
            completed = false;  
        }
    });
}
function investmentValidation(trm1, version) {
    var errorMessageElement;
    let currentAmount = "";
    let investAmount = 0;
    currentAmount = document.getElementById("amount1").value;
    //currentAmount = document.getElementById("newInvestAmount").value; ////
    //console.log("s94A", s94)
    if (currentAmount !== "") {
        //console.log("currentAmount", currentAmount, typeof currentAmount);
        //console.log("trm1:", trm1, typeof trm1[2]);
        investAmount = getNumber(currentAmount);
    }
    if (investAmount > 0) {
        if (investAmount >= trm1[2]) {
            //console.log("true >= lowerLimit");
            document.getElementById("amount1Error").innerText = "";
            document.getElementById("termValidationError1").innerText = "";
            document.getElementById("termValidationError2").innerText = "";
            document.getElementById("termValidationError3").innerText = "";
            s94 = 0;
        }
        if (investAmount < trm1[2]) {
            //console.log("true < lowerLimit");
            document.getElementById("amount1Error").innerText = "The investment amount is lower than the minimum required.";
            document.getElementById("termValidationError1").innerText = "Please adjust the investment amount or select terms within upper and lower limits.";
            document.getElementById("termValidationError2").innerText = "Please adjust the investment amount or select terms within upper and lower limits.";
            s94 = 1;
        }
        if (investAmount > trm1[3] && trm1[3] !== 0) {
            //console.log("true > upperLimit");
            document.getElementById("amount1Error").innerText = "The investment amount is greater than the upper limit for the note selected.";
            document.getElementById("termValidationError1").innerText = "Please adjust the investment amount or select terms within upper and lower limits.";
            document.getElementById("termValidationError2").innerText = "Please adjust the investment amount or select terms within upper and lower limits.";
            s94 = 1;
        }
        if (s94 === 5) {
            if (investAmount <= unaccreditedLimit) {
            document.getElementById("amount1Error").innerText = "";
            document.getElementById("submitError2").innerText = ""; 
            s95 = 0
            }
            if (investAmount > unaccreditedLimit) {
            document.getElementById("amount1ValidationError").innerText = "The Unaccredited Investor Limit is " + getString(unaccreditedLimit);
            document.getElementById("submitError2").innerText = "Please Adjust the Investment Amount";   
            s95 = 5; 
        }
        }
        //console.log("s94B", s94)
    }
}
function versions() { // global trm
    //console.log("contractCode", contractCode);
    let contractCode1 = contractCode;
    let trm = ["", "", "", "", ""];

// Destructure contractCode into trm
    [trm[0], trm[1], trm[2], trm[3], trm[4]] = contractCode1.split(" ");
    trm4 = trm[4];
    //console.log("trm", trm);
    //console.log("contractCode after reassignment", contractCode);
    var currentContract = "contractVersions.txt";
    if (trm[4] === "2.5") { //////////////////////
        trm[4] = "2";
    }
    let version = trm[4]; // already declared globally
    //console.log("version: ", version, "trm[4] =", trm[4])
    var index;
    var checkboxes = document.querySelectorAll(".section2");
    checkboxes.forEach(function(checkbox) {   
    if (checkbox.checked) {
    switch (checkbox.id) {
        case "product1":
        index = 0; 
        break;
        case "product2":
        index = 1; 
        break;
        case "product3":
        index = 2; 
        break;
        case "product4":
        index = 3; 
        break;
        case "product5":
        index = 4; 
        break;
          case "product6":
        index = 5; 
        break;
        case "product7":
        index = 6; 
        break;
        case "product8":
        index = 7; 
        break;
        case "product9":
        index = 8; 
        break;
};
};
});
//console.log("version: ", version)
trm1[0] = ContractTerms[version]["B"][index].term;
trm1[1] = ContractTerms[version]["B"][index].APR;
trm1[2] = ContractTerms[version]["B"][index].lLimit;
trm1[3] = ContractTerms[version]["B"][index].uLimit;
investmentValidation(trm1, version)
return trm1;
}
function contractVersions(contractA, contractCode) { // not used replaced with contractVersions.js??
    var sectionCode = 0; versions();
    while (sectionCode < 5 ) {
        if (sectionCode == 3) {
            sectionCode = 4;
        }
        switch (trm[sectionCode]){
        case "A2":
            contractA.Value = version[cv][1]; 
            contractA.reinvestmentAmount = "";
        break;
        case "A3":
            contractA.Value = version[cv][2];  
            contractA.reinvestmentAmount = "ALL";
        break;
        case "A4":
            contractA.Value = version[cv][3]; 
            contractA.reinvestmentAmount = "investmentAmount";
        break;
        case "B1":
            x++;
            [trm1[0], trm1[1], trm1[2], trm1[3]] = version[x][4].split(", ");
            contractA.Term = trm1[0];
            contractA.interestRate = trm1[1]; 
            lLimit = trm1[2]; 
            uLimit = trm1[3];
            managedLienStatus = "Managed First-Tier Lien"; 
        break;
        case "B2":
            x++;
            [trm1[0], trm1[1], trm1[2], trm1[3]] = version[x][4].split(", ");
            contractA.Term = trm1[0]; 
            contractA.interestRate = trm1[1]; 
             lLimit = trm1[2]; 
             uLimit = trm1[3];
             managedLienStatus = "Managed First-Tier Lien";  
        break;
        case "B3":
            x++;
            [trm1[0], trm1[1], trm1[2], trm1[3]] = version[x][4].split(", ");
            contractA.Term = trm1[0]; 
            contractA.interestRate = trm1[1]; 
            lLimit = trm1[2];  
            uLimit = trm1[3];
            managedLienStatus = "Managed First-Tier Lien"; 
        break;
        case "B4":
            x++;
            [trm1[0], trm1[1], trm1[2], trm1[3]] = version[x][4].split(", ");
            contractA.Term = trm1[0];
            contractA.interestRate = trm1[1];
            lLimit = trm1[2];
            uLimit = trm1[3];
            managedLienStatus = "Managed First-Tier Lien";
        break;
        case "B5":
            x++;
            [trm1[0], trm1[1], trm1[2], trm1[3]] = version[x][4].split(", ");
            contractA.Term = trm1[0];
            contractA.interestRate = trm1[1];
            lLimit = trm1[2];
            uLimit = trm1[3];
            managedLienStatus = "Managed First-Tier Lien";
        break;
        case "B6":
            x++;
            [trm1[0], trm1[1], trm1[2], trm1[3]] = version[x][4].split(", "); 
            contractA.Term = trm1[0];  
            contractA.interestRate = trm1[1];  
            lLimit = trm1[2];  
            uLimit = trm1[3];
            managedLienStatus = "Managed First-Tier Lien"; 
        break;
        case "B7":
            x++;
            [trm1[0], trm1[1], trm1[2], trm1[3]] = version[x][4].split(", ");  
            contractA.Term = trm1[0]; 
            contractA.interestRate = trm1[1]; 
            lLimit = trm1[2]; 
            uLimit = trm1[3];
            managedLienStatus = "Managed First-Tier Lien"; 
        break;
        case "B8":
            x++;
            [trm1[0], trm1[1], trm1[2], trm1[3]] = version[x][4].split(", "); 
            contractA.Term = trm1[0]; 
            contractA.interestRate = trm1[1];
            lLimit = trm1[2];  
            uLimit = trm1[3];
            managedLienStatus = "Managed First-Tier Lien";  
        break;
        case "B9":
            x++;
            [trm1[0], trm1[1], trm1[2], trm1[3]] = version[x][4].split(", ");
            contractA.Term = trm1[0]; 
            contractA.interestRate = trm1[1]; 
            lLimit = trm1[2];  
            uLimit = trm1[3];
            managedLienStatus = "Managed Second-Tier Lien";  
        break;
        case "C1":
            x++;
          
        break;
    } 
};
};
function input2(change) {
    var input1val = []; let x = 0; var updateExpression = ""; let newObj = {}; key = []; value = [];
    for ([key, value] of Object.entries(change)) {
        newObj[key] = value;
        input1val[x] = newObj[key];
        updateExpression = updateExpression + "#input1val[x] = :" + newObj[key] + ", ";
    }
    while (x < key.length) {
        if (x < change.length - 1) {
            updateExpression = updateExpression + ", ";
        }
        x=x+1;
    }
    updateExpression = "set " + updateExpression; 
    uE = updateExpression; dataSetA[7][1] = uE;
};
function bColor(button, color1) {  
    button.style.backgroundColor = color1;
};
function clear(str) {
    if (/\s*/.test(str)) {
        console.log("INSIDE STR")
    str = "";
    return str;
    }
    return str;
}
function isEmptyObject(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}
function clearUploads() {
    var input = document.getElementById("docInput");
    input.value = "";
    window.selectedFiles = {};
    var files = window.selectedFiles;
    files = "";
    var fileList = document.getElementById("fileList");
    fileList.innerHTML = "";
    if (submitted === false) {
    document.getElementById("closing").innerText = "";
    } 
    if (f1 = 1){
        document.getElementById("closing").innerHTML = "<br>The payment was already uploaded to the server."
        submitted = false;
    }
}
function setDataAndState() {
document.querySelectorAll("input").forEach(input => {
        if (input.type !== "button" || (input.id !== "upload" && input.id !== "cancel")) {
            input.disabled = true;
        }
    });
    document.querySelectorAll("select").forEach(select => {
        const selectedValue = select.value;
        Array.from(select.options).forEach(option => {
            if (option.value === selectedValue) {
                option.setAttribute("selected", "selected");
            } else {
                option.removeAttribute("selected");
            }
        });
        select.disabled = true;
    });
}
/*
    document.querySelectorAll("select").forEach(select => {
        select.disabled = true;
    });
    const select = document.querySelector("#accredited_status");
    const optionsArray = Array.from(select.options).map(opt => ({
        text: opt.text,
        value: opt.value,
        isSelected: opt.selected
    }));
    console.log("Options array:", optionsArray);

    const selected = select.value;
    console.log("Selected value:", selected);

    // For export preparation
    Array.from(select.options).forEach(option => {
        if (option.value === selected) {
            option.setAttribute("selected", "selected");
        } else {
            option.removeAttribute("selected");
        }
    });
}
*/
function convertImageToBase64(img) {
    const canvas = document.createElement("canvas");
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    return canvas.toDataURL("image/jpeg", 1.0);
}
function preloadImagesFromClone(images) {
    const loadPromises = images.map(img => {
        const preload = new Image();
        //preload.crossOrigin = "anonymous"; // ensures canvas can use it if from same origin
        preload.src = img.src;
        return new Promise(resolve => {
            preload.onload = () => {
                try {
                    img.src = convertImageToBase64(preload);
                } catch {
                }
                resolve();
            };
            preload.onerror = () => resolve();
        });
    });
    return Promise.all(loadPromises);
}

function initiateSaveDocument() {
    return new Promise(resolve => {
        //console.log("initiateSaveDocument");

        const clonedBody = document.body.cloneNode(true);
        const seal = clonedBody.querySelector('#image_s');
        if (seal) {
            seal.src = "/Images/contractualSeal_e.jpg";
            seal.style.display = "inline-block";
        }

        const logo = clonedBody.querySelector('#companyLogo');
        if (logo) {
            logo.removeAttribute("width");
            logo.removeAttribute("height");
            logo.style.width = "6.5in";
            logo.style.height = "auto";
        }

        const contractImages = [logo, seal].filter(Boolean);

        preloadImagesFromClone(contractImages)
            .then(() => {
                saveDocument(clonedBody);
                resolve();
            })
            .catch(err => {
                console.warn("Image preload issue:", err);
                saveDocument(clonedBody);
                resolve();
            });
    });
}

function saveDocument(clonedBody) {
    console.log("clonedBody", clonedBody)
    clonedBody.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        if (checkbox.checked) {
            checkbox.setAttribute("checked", "checked");
        } else {
            checkbox.removeAttribute("checked");
        }
    }); 
    clonedBody.querySelectorAll('input[type="text"], input[type="number"], input[type="email"], textarea').forEach(input => {
        input.setAttribute("value", input.value);
        input.style.textAlign = "left"; 
    });
    clonedBody.querySelectorAll("select").forEach(select => {
        const selectedValue = select.value;
        Array.from(select.options).forEach(option => {
            if (option.value === selectedValue) {
                option.setAttribute("selected", "selected");
            } else {
                option.removeAttribute("selected");
            }
        });
    });
  //clonedBody.querySelectorAll("img").forEach(img => {
    //console.log(`Processing image: ${img.src}`);
    /*
    if (img.id === "image_s") {
        img.src = "Images/contractualSeal_e.jpg";
        img.style.display = "block";
        img.onload = () => {
            while (!img.complete) {
            if (img.complete && img.naturalWidth !== 0) {
                try {
                    img.src = convertImageToBase64(img);
                } catch (err) {}
            }
        }
        };
    } else if (img.complete && img.naturalWidth !== 0) {
        try {
            img.src = convertImageToBase64(img);
        } catch (err) {}
    }
    */
//});
let notaryDiv = clonedBody.querySelector("#notary");
if (notaryDiv) {
    notaryDiv.style.display = "inline-block";
}
clonedBody.querySelectorAll(".navigation, .loginMenuBar, .images, #contractCodeButton, #upload, #cancel").forEach(element => {
element.remove();
});
if (document.getElementById("fileList").innerText) {
clonedBody.querySelectorAll("#docInput").forEach(element => {
element.remove();
});
}
let footer = clonedBody.querySelector(".footer3");
if (footer) {
footer.remove();
}
    let staticHtml = '<!DOCTYPE html><html><head><title>Contract</title>';
    staticHtml += '<style>'; 
    staticHtml += 'body { margin: 0; margin-right: 1in; margin-left: 0.75in; background-color: white; color: black; font-family: Arial, sans-serif; font-size: 12pt; text-align: left; width: 100%; max-width: 6.5in; box-sizing: border-box;}';
    //staticHtml += 'body { width: 8.5in; margin: 1in; background-color: white; color: black; font-family: Arial, sans-serif; text-align: left; font-size: 12pt; }'; // Set font size to 12pt
    staticHtml += 'h1, h2, h3, h4, h5, h6 { text-align: center; }';
    staticHtml += 'input, select { background-color: white; color: black; text-align: left; }'; // Left justify user data inside text boxes
    //staticHtml += 'p { margin: 3px 10px; }';
    staticHtml += 'p {margin-top: 0.5em; margin-bottom: 0.5em; margin-left: 0px; margin-right: 0px;}'
    staticHtml += '.checkbox-container { margin-bottom: 10px; padding-left: 15px; font-family: Arial; font-size: 12pt; }'; // Set font size to 12pt
    staticHtml += '.checkbox-container input[type="checkbox"] { display: inline-block; vertical-align: top; position: relative; top: 0px; }';
    staticHtml += '.checkbox-label { display: inline-block; width: 90%; margin-left: 10px; text-indent: 0px; font-size: 12pt; }'; // Set font size to 12pt
    staticHtml += '#checkbox-label #product5Error { display: inline-block; position: relative; color: #f70707; width: 90%; margin-left: 20px; }';
    //staticHtml += '.contractFormA { display: inline-block; width: 62%; text-align: right; height: 12pt; padding: 4px; line-height: 1.4; }'; // Apply contractFormA styles
    //staticHtml += '.contractFormA { display: inline-block; width: 90%; text-align: right; height: 12pt; padding: 4px; line-height: 1.4; margin-right: 1in;}'; // Apply contractFormA styles
    staticHtml += '.contractFormA { display: inline-block; width: 6.25in; max-width: 6.5in; text-align: right; padding: 4px; line-height: 1.4; margin-right: 1in;}'
      
    staticHtml += '#fileList {padding-top: 4px;}';
    //staticHtml += '.container { align-items: center; width: auto; overflow: auto; padding: 0; margin-left: -44px; margin-right: 44px; margin-top: -44px; margin-bottom: 44px; }'; // Remove padding from container
    staticHtml += '.container { align-items: center; width: 8.5in 11in; overflow: auto; padding: 0; margin-left: 0px; margin-right: 0px; margin-top: 0px; margin-bottom: 0px; }'; // Remove padding from container
    staticHtml += '.content2 { margin-top: 0px; width: 8.5in 11in; padding: 0; overflow: hidden; }';
    //staticHtml += '.container #companyLogo .logo { overflow: visible; padding: 0 auto; margin: 0 auto; margin-top: -96px; }';
    //staticHtml += '.container #companyLogo .logo { overflow: visible; padding: 0 auto; margin: 0 0; margin-top: -180px; }';
    //staticHtml += '.container #companyLogo .logo img { max-width: 68%; height: auto; display: block; margin: 0 0; align-items: center; }';
    staticHtml += '#companyLogo { width: 6.5in; max-width: 100%; height: auto; display: block; margin: 0 auto; }';
    staticHtml += '#companyLogo { align-items: center; padding-bottom 5px; padding-top: 5px; }';
    staticHtml += '@page { size: 8.5in 11in; margin-top: 1in; margin-bottom: 1in; }';
    staticHtml += '@page #companyLogo .logo img { width: 6.5in; max-width: 100%; height: auto; display: block; margin: 0 auto; }';
    staticHtml += '@page .contractFormA { display: inline-block; width: 6.25in; max-width: 6.5in; text-align: right; padding: 4px; line-height: 1.4; margin-right: 1in;}' 
    //staticHtml += '@page { margin-left: 0in; margin-right: 0in; margin-top: 1in;  size: 8.5in 11in; /* US Letter */ }';
    // staticHtml += '.footer { text-align: center; margin-top: 0px ;margin-left: -44px; margin-right: 44px; margin-bottom: 0px; clear: both; display: block; }';
    staticHtml += '.content2 #image_s { display: inline-block; }';
    staticHtml += '.content2 .footer { text-align: center; padding-top: 5in; margin-left: 0px; margin-right: 0px; margin-bottom: 0px; display: block; }';
    //staticHtml += 'body { margin: 0.35em; /* handled by @page */ width: 100%; max-width: 100%; }';
    staticHtml += 'img { max-width: 99%; height: auto; margin: 0 auto; }';
    staticHtml += '</style>';
    staticHtml += '</head><body>';
    // Left justify specific headings by ID
    clonedBody.querySelectorAll("h1, h2, h3, h4, h5, h6").forEach(heading => {
        if (heading.id === "repaymentOptions" || heading.id === "selectProduct" || heading.id === "issueCode" || heading.id === "resultA" || heading.id === "submitChanges" || heading.id === "inlineBlock" || heading.id === "contactRules" || heading.id === "getCodes" || heading.id ==="imageUpload" ) {
            heading.style.textAlign = "left";
        }
    });
    staticHtml += clonedBody.innerHTML;
        if (footer) {
            //console.log("footer2", footer);
            staticHtml += '<div class="footer">' + footer.innerHTML + "</div>";
        }
    staticHtml += "</body></html>";
    convertHtml(staticHtml, clonedBody);
    // console.log("staticHtml", staticHtml)
    // console.log("clonedBody", clonedBody)
    const blob = new Blob([staticHtml], { type: "text/html" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "JP Levesque Builders.html";
    document.body.appendChild(link); 
    link.click();
    document.body.removeChild(link); 
}

function clearDocument() {
    if (completed === true) {
        window.open("contractA.html", "_blank");
    } else {
        window.open("contractA.html", "_self");
    } return;
    document.getElementById("submitError").innerText = "";
    var input = document.getElementById("docInput");
    input.value = "";
    docInput.value = "";
    window.selectedFiles = [];
    var files = window.selectedFiles;
    files = "";
    var fileList = document.getElementById("fileList");
    fileList.innerHTML = "";
    document.getElementById("accredited_status").value="I am";
    document.getElementById("signature1").value="";
    result = "";
    contractCode = "";
    var form = document.getElementById("contractForm");
    var inputs = form.getElementsByTagName("input");
    for (var i = 0; i < inputs.length; i++) {
    inputs[i].value = "";
    } 
    contractCode = "";
    result = "";
    sections.forEach(function(section) {
    var checkboxes = document.getElementsByClassName(section);
    for (var i = 0; i < checkboxes.length; i++) {
    checkboxes[i].checked = false;
    }
    });
    document.getElementById("resultA").innerText = result;
    document.getElementById("termCode").innerHTML = result;
    formData(userData);
    contractSeal2();
    console.log("button disable reset", submitButton)
    submitButton.disabled = false;
    selectFiles.disabled = false;
    // complete = null;
};

function startNewContract() {
    return {
        Username: "",
        Timestamp: "",
        oeTimestamp: "",
        identificationNumber: "",
        checkNumber: "",
        routingNumber: "",
        accountNumber: "",
        legalName: "",
        streetAddress: "",
        Apartment: "",
        City: "",
        State: "",
        zipCode: "",
        Country: "",
        phoneNumber: "",
        Accreditation: "",
        contactEmail: "",
        eSignature: "",
        folderKey: "",
        contractCode: "",
        Status: "",
        interestRate: "",
        Term: "",
        investmentAmount: "",
        uploadDate: "",
        chkStatus: "",
        rolloverStatus: "",
        maturityDate: "",
        earnedInterest: "",
        Value: "",
        repaymentAmount: "",
        Property: "",
        rolloverRate: "",
        reinvestmentAmount: "",
        daysWaiting: "",
        contractVersions: "",
        repaymentOptions: "",
        managedLienStatus: "",
        lLimit: "",
        uLimit: ""
    };
    //contractA = JSON.parse(JSON.stringify(contractA));
}

function autoData(contractA, contractCode, timestamp) {
    contractA.Username = dataSetA[2][1];
    contractA.Timestamp = timestamp;
    contractA.legalName = document.getElementById("legalName1").value;
    contractA.Status = "Pending";
    contractA.uploadDate = timestamp;
    contractA.contractVersion = trm4;
    contractA.eSignature = document.getElementById("signature1").value;
    contractA.contractCode = contractCode;
    contractA.streetAddress = document.getElementById("mailingAddress1").value;
    contractA.City = document.getElementById("city1").value;
    contractA.State = document.getElementById("state1").value;
    contractA.zipCode = document.getElementById("zipCode1").value;
    contractA.Country = document.getElementById("country1").value;
    contractA.phoneNumber = document.getElementById("phoneNumber1").value;
    contractA.contactEmail = document.getElementById("email1").value;
    contractA.investmentAmount = getString(getNumber(document.getElementById("amount1").value));
    contractA.repaymentAmount = getString(getNumber(document.getElementById("repaymentAmount").value));
    contractA.earnedInterest = getString(getNumber(document.getElementById("earnedIncome").value));
    contractA.Accreditation = document.getElementById("accredited_status").value;
    contractA.Value = getString((getNumber(contractA.earnedInterest) + getNumber(contractA.investmentAmount))); 
    let aprValue = document.getElementById("iAPR1").value.replace(' percent', '').trim();
    let iAPR = parseFloat(aprValue);
    //let mTerm = parseInt(fTerm(document.getElementById("iTerm1").value), 10);
    contractA.Term = fTerm(document.getElementById("iTerm1").value);
    let iAPRStr = iAPR.toString(); // Use toString method for conversion
    //console.log("aprValue", typeof aprValue, aprValue);
    //console.log("APR", typeof iAPR, iAPR);
    //console.log("contractA.Term", typeof contractA.Term, contractA.Term);
    //console.log("Before conversion, iAPR:", iAPR);
    //console.log("Converted iAPR to string:", typeof iAPRStr, iAPRStr);   
    contractA.Timestamp = String(timestamp);
    contractA.Status = "Pending";
    contractA.maturityDate = "Pending";
    contractA.interestRate = iAPRStr;
    contractA.reinvestmentAmount = reValue();
    //console.log("Mature Value", typeof contractA.Value, contractA.Value);
    //console.log("interestRateA", typeof contractA.interestRate, contractA.interestRate);
    //console.log("contractA.repaymentAmount", contractA.repaymentAmount, typeof contractA.repaymentAmount)
    //console.log("CONTRACTA", contractA);
};

function DateTime() {
    if (today == undefined) {
    systemTime = new Date(Timestamp);
    } else {
    systemTime = new Date();
    systemTime = systemTime.toString();
    }
    todaysDate = systemTime.split(" ");
    [todaysDate[0], todaysDate[1], todaysDate[2], todaysDate[3], todaysDate[4], todaysDate[5], todaysDate[6], todaysDate[7]] = systemTime.split(" "); 
    todaysDate[8] = todaysDate[1] + " " + todaysDate[2] + ", " + todaysDate[3];
    return todaysDate[8];
};
function reValue() {
    let rf = [];
    let value;
    rf = contractA.contractCode.split(" ");
    if (rf[0] === "A2") {
        value = getString(0);
    }
    if (rf[0] === "A3") {
        value = contractA.repaymentAmount;
        contractA.repaymentAmount = getString(0);
    }
    if (rf[0] === "A4") {
        value = contractA.investmentAmount;
        contractA.repaymentAmount = contractA.earnedInterest;
    }
    return value;
}
function mmddyyyyToTimestamp(dateStr) {
    if (typeof dateStr !== "string") return null;
    const parts = dateStr.split("/");
    if (parts.length !== 3) return null;
    const [mm, dd, yyyy] = parts.map(p => p.trim());
    const month = Number(mm);
    const day   = Number(dd);
    const year  = Number(yyyy);
    if (!month || !day || !year) return null;
    // JS Date months are 0-based
    const d = new Date(year, month - 1, day);
    if (
        d.getFullYear() !== year ||
        d.getMonth() !== month - 1 ||
        d.getDate() !== day
    ) {
        return null;
    }
    return d.getTime();
}
function dateTimes(recdTime) {
    console.log("Received Time:", recdTime, typeof recdTime);
    if (Array.isArray(recdTime)) {
        recdTime = recdTime[0];
    }
    recdTime = recdTime != null ? String(recdTime).trim() : "";
    if (
        recdTime === "" ||
        recdTime === "undefined" ||
        recdTime === "null" ||
        recdTime === "NaN"
    ) {
        console.error("Invalid recdTime:", recdTime);
        return "error";
    }
    if (
        recdTime === "Pending" ||
        recdTime === "Indefinite" ||
        recdTime.includes("(Example)")
    ) {
        return recdTime;
    }
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(recdTime)) {
        return recdTime;
    }
    if (!isNaN(recdTime)) {
        let ts = Number(recdTime);
        if (ts < 10000000000) {
            ts *= 1000;
        }
        const d = new Date(ts);
        if (!isNaN(d.getTime())) {
            return d.toLocaleDateString("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "numeric"
            });
        }
        console.error("Invalid timestamp:", recdTime);
        return "error";
    }
    const parsed = Date.parse(recdTime);
    if (!isNaN(parsed)) {
        const d = new Date(parsed);
        return d.toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric"
        });
    }
    console.error("Unrecognized date format:", recdTime);
    return "error";
}
function dateTimesA(recdTime) {
    console.log("Received Time", recdTime, typeof recdTime);
    if (Array.isArray(recdTime)) {
        recdTime = recdTime[0];
        console.log("Extracted from array", recdTime, typeof recdTime);
    }
    if (!recdTime) {
        console.error("Invalid recdTime:", recdTime);
        return "error";
    }
    if (!recdTime || recdTime === "undefined" || recdTime === "null" || isNaN(Number(recdTime))) {
        console.error("Invalid recdTime:", recdTime);
        return "error";
    }
    if (typeof recdTime === 'string') {
        if (recdTime.includes("(Example)")) {
            return recdTime;
        }
        if (recdTime === 'Pending') {
            return recdTime;
        }
        if (recdTime === 'Indefinite') {
            return recdTime;
        }
        if (!isNaN(Date.parse(recdTime))) {
            const num = Number(recdTime);
            const date = new Date(num);
            return date.toLocaleDateString("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "2-digit"
            });
        }
    }
    let parsedTime = parseInt(recdTime, 10);
    if (parsedTime < 10000000000) {
        parsedTime *= 1000;
    }
    if (isNaN(parsedTime)) {
        console.log(parsedTime)
        console.error("Invalid parsedTime:", parsedTime);
        return "error";
    }
    let systemTime = new Date(parsedTime);
    if (isNaN(systemTime.getTime())) {
        console.error("object error:", systemTime);
        return "error";
    }
    return systemTime.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "2-digit"
    });
}

function interestCalc(Origin, Amount, Rate){
    let amount = getNumber(Amount);
    let termStart = new Date(Origin);
    let currentDate = new Date();
    let timeUnits = currentDate - termStart;
    let totalDays = timeUnits / (24 * 60 * 60 * 1000);
    days = Math.floor(totalDays);
    let rate = parseFloat(Rate) / 100;
    let dailyRate = rate / 365;
    let number3 = amount * Math.pow(1 + dailyRate, days);
    number3 = number3 - amount;
    return number3;
};
function formData(userData) {
    document.getElementById("mailingAddress1").value = userData.streetAddress
    document.getElementById("city1").value = userData.City
    document.getElementById("state1").value = userData.State 
    document.getElementById("zipCode1").value = userData.zipCode
    document.getElementById("country1").value = userData.Country 
    document.getElementById("phoneNumber1").value = userData.phoneNumber
    document.getElementById("email1").value = String(userData.contactEmail)
};
function overwriteNumber(originalNumber) {
    let numDigits = originalNumber.toString().length;
    let newNumber = Number("1".repeat(numDigits));
    return newNumber;
  };
  function overwriteData(table) {
    for (let i = 0; i < table.length; i++) {
  
      for (let j = 0; j < table[i].length; j++) {
        if (typeof table[i][j] === "string") {
          let length = table[i][j].length; 
          table[i][j] = "x".repeat(length + 1); 
        } else if (typeof table[i][j] === "number") {
          let originalNumber = table[i][j];
          reNumber = overwriteNumber(originalNumber);
          table[i][j] = renumber;
          originalNumber = reNumber;
          reNumber = "";
  
        }
      } //
  
    }
  };